(function() {
	'use strict';

	angular
		.module('mcweb', ['ui.bootstrap', 'ui.router', 'ngSanitize'])
		.run(runBlock);
		
	function runBlock($location, dataService, webSessionStorage, $state, headerService, $log,
		loginService, $http, $rootScope, custData, custDataDev, appValidationService,
		setCustService, modalService, lclURL, minFinURL, protectURL, statsURL, $window) {
		var sDatabaseID = "";
		var sDataSource = "";
		var searchObject = $location.search();
		var sRetCodeToDelete = "";

// searchObject.conf = "NWTX-DEV";		//TESTING		

		if (searchObject.ReturnCode) {
			sRetCodeToDelete = searchObject.ReturnCode; }
		else if (webSessionStorage.getStoredData('sReturnCode') != null) {
			/* if "Refresh" occurs, this allows login so as not to force
				user to manually login again: */
			sRetCodeToDelete = webSessionStorage.getStoredData('sReturnCode');
		}
		
		//Login with ReturnCode ==> LoginService calls SecDeleteReturnCode immediately after login
		if (sRetCodeToDelete !=  "") {
			loginService.secReturnLogin(sRetCodeToDelete)
			.then(function (data) {
				if (data[0].DATABASEID != "") {
					sDataSource = data[0].DATABASEID;
					setCustService.fromDataSource(sDataSource);
				
					if (data[0].USERID != "") {	
						loginService.login(data[0].USERNAME, data[0].PASSWORD)
						.then(function(loginReturn) {
							if (loginReturn[0].SECUSERLOGIN[0].RESULT == "Success") {
								
								/* Determine landing page... */
								var permission = appValidationService.validateAccess();
								if (permission == "Valid") {
									$rootScope.sCurForm = 'Contact Information';
									$state.go('contactInfo');
								} else if (permission == "MultApps") {
									$state.go('selApp');
								} else if (permission != "Denied") { 
									var sPath = "";
									switch(permission) {
										case "ChLeaders": sPath = lclURL; break;
										case "MinFin": sPath = minFinURL; break;
										case "ProRef":
										case "LCAMgmt": sPath = protectURL; break;
										case "Statistics": sPath = statsURL; break;
									}
									if (sPath != "") {
										loginService.secReturnReset(loginService.user.RETURNCODE, 1)
										.then(function(result) {
											if (result[0].RESULT == "Success") {
												$window.location.replace(sPath+"?ReturnCode=" +
													loginService.user.RETURNCODE);
											}
										});
									}
								} else {
									$rootScope.sCurForm = 'Login';
									$state.go('login'); 
								}
							}	
						});
					} else if (data[0].USERNAME == "Expired") {
						modalService.okAlert("Expired", 
							"Your session login has expired.<br><br>" +
							"Please log in again to continue.");
						$state.go('login');	
					}
				}	
			});
		}
		
		// Login page with Conference identified:
		else {
			if (searchObject.conf) {
				sDatabaseID = searchObject.conf;
				setCustService.fromDatabaseID(sDatabaseID);
			} else { 
				webSessionStorage.setStoredData('sDataSource', "HelpFalcon");
			}
		}
	}
	
})();

(function () {
    'use strict';
    
    angular
        .module('mcweb')
        .factory('webSessionStorage', webSessionStorage);
        
    function webSessionStorage($window) {
        var store = $window.sessionStorage;
        var factory = {};
        
        factory.getStoredData = function (sKey) {
            return store.getItem(sKey);
        };
        
        factory.setStoredData = function (sKey, sData) {
            if (sData) {
                store.setItem(sKey, sData);
            }  
            else {
                store.removeItem(sKey);
            }
        };
        
        return factory;
	}
    
})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('validatorService', validatorService);

	validatorService.$inject = [];	

    function validatorService() {
		var service = {
			emailIsValid: emailIsValid,
			phoneIsValid: phoneIsValid
		};
		
		return service;
		
		function emailIsValid(sEmail) {
			var isValid = false;
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

			if (sEmail.search(filter) == -1) {
				return isValid = false;
			} else { isValid = true; }
			
			return isValid;
		}
		
		function phoneIsValid(phone) {
			var isValid = false;
			var numOnlyPattern = /[^0-9]/g;
			var valPhone = String(phone);
			var numOnlyPh = valPhone.replace(numOnlyPattern,'');
			
			if (String(numOnlyPh).length == 10) { return true; }
			
			return isValid;
		
		}
				
	}
})();	 
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('emailValidator', emailValidator);

	function emailValidator() {
		var factory = {
			validateEmail: validateEmail
		};
		
		return factory;
		
		function validateEmail(sEmail) {
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
				
				if (sEmail.search(filter) == -1) {
					return false;
				} else {
					return true;
			}
		}		
	}

})();	 
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('userAcctEmails', userAcctEmails);
	
	userAcctEmails.$inject = ['$http','webSessionStorage','$rootScope','protectURL','mcWebCFC'];

	function userAcctEmails($http, webSessionStorage, $rootScope, protectURL, mcWebCFC) {
		var factory = {
			sendSelfInitUAEmail: sendSelfInitUAEmail
		};
		
		return factory;
		
		
		function sendSelfInitUAEmail(sUserName, sEmail) {
			var sDatabaseID = webSessionStorage.getStoredData("sDatabaseID");
			var sEmailContent = "";
			var sFrom = "";
			var sReplyTo = "";
			var returnURL = protectURL + "?conf=" + sDatabaseID;
			
			sEmailContent = "Your MissionConnect account has been initialized.<br><br>" +
				"For your records, the secure website address is:<br>" +
				"<font color='#0000FF'><a href=" + returnURL + "><u>" + returnURL + 
				"</u></a></font><br><br>" +
				"Your Username is: " + sUserName + "<br><br>" +
				"Please store your Username and Password in a safe place for future reference.<br><br>" +
				"If you forget your password, you can have it sent to this email address by " +
				"clicking the &quot;Forgot Password?&quot; button on the login page.<br><br>" +
				"Login tips:<br>" +
				"Type your username and password in. Do not use a copy and paste method, as that sometimes " +
				"includes additional data that does not display, but will cause it not to work.<br>" +
				"Both the username and password are case sensitive. Capital letters should be entered " +
				"as capitalized, etc.";
				
			switch (sDatabaseID) {
				case "MC":
					sReplyTo = "eromero@mccurdy.org";
					sFrom = "McCurdy Ministries Volunteer Screening <" + sReplyTo + ">";
				break;
				default:
					sReplyTo = "testing@greatspirit.com";
					sFrom = "MCWebApps Testing <" + sReplyTo + ">";
				break;	
			}	
			
			var params = {
				method: "EmailSendCustom",
				sEmailAddr: sEmail,
				sFrom: sFrom,
				sReplyTo: sReplyTo,
				sSubject: "Account Information",
				sEmailContent: sEmailContent
			};
			return $http.post(mcWebCFC, params)
			.then(function (result) {
				return result.data;
			});
		}
		
	}
})();
(function() {
    'use strict';
 
	angular
        .module('mcweb')
        .factory('setCustService', setCustService);

	setCustService.$inject = ['custData','custDataDev','webSessionStorage','headerService',
		'$rootScope'];	

    function setCustService(custData, custDataDev, webSessionStorage, headerService,
		$rootScope) {
		var service = {
			fromDataSource: fromDataSource,
			fromDatabaseID: fromDatabaseID
		};
		return service;
				
		function fromDataSource(dataSource) {
			webSessionStorage.setStoredData('sDataSource', dataSource);

			if (dataSource.slice(-3) == "Dev" || dataSource == "FalconVideos") {
				for (var i=0; i<custDataDev.length; i++) {
					custData.push(custDataDev[i]);
				}
			}
			
			for (i=0; i<custData.length; i++) {
				if (custData[i].DataSource == dataSource) {
					webSessionStorage.setStoredData('sDatabaseID', custData[i].DatabaseID);
					headerService.setCustomer(custData[i].CustomerName);					
					$rootScope.$broadcast('updateCustomer');
				break; }
			}
		}
		
		function fromDatabaseID(databaseID) {
			webSessionStorage.setStoredData('sDatabaseID', databaseID);
			
			if (databaseID.slice(-3) == "DEV" || databaseID == "VID") {
				for (var i=0; i<custDataDev.length; i++) {
					custData.push(custDataDev[i]);
				}
			}

			for (i=0; i<custData.length; i++) {
				if (custData[i].DatabaseID == databaseID) {
					webSessionStorage.setStoredData('sDataSource', custData[i].DataSource);
					headerService.setCustomer(custData[i].CustomerName);					
					$rootScope.$broadcast('updateCustomer');
				break; }
			}
		}
		
	}
})();	

(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('referRefEmail', referRefEmail);
	
	referRefEmail.$inject = ['webSessionStorage','$rootScope'];

	function referRefEmail(webSessionStorage, $rootScope) {
		var factory = {
			getEmailContent: getEmailContent
		};
		return factory;
		
		
		function getEmailContent(sApplicant, sReferralUserName, sReferralName, sReturnCode) {
			var sDatabaseID = webSessionStorage.getStoredData("sDatabaseID");
			var sEmailContent = "";
				var sRefURLLink = "https://umcdata.net/MissionConnect/Public/Protect/Ref/Web_Protect_Ref.html?ReturnCode=" + sReturnCode; 
			var sProRefsURL = "https://umcdata.net/MissionConnect/Public/ProtectReferences/#/index.html?conf=" + sDatabaseID;
			
			// ONLY for MoPastor Ref @ present! Customize text for others when needed:	
			switch (sDatabaseID) {
				case "MO": case "MO-DEV":
					sEmailContent = sReferralName + ",<br><br>A reference for " +
						sApplicant + " has been referred to you by " +
						$rootScope.user.USERFULLNAME + " for completion. This is to " +
						"fulfill a requirement in the process for Safe Sanctuaries " +
						"Certification.<br><br>";				
					
					sEmailContent += "We now have a CONVENIENT NEW WAY for you to manage your " +
						"reference requests. You may now login to your Safe Sanctuaries " +
						"account online and complete all of your waiting pastoral reference " +
						"requests at once. No more losing the request email among all the " +
						"other emails in your Inbox. " +
						"<b>This will also now work from your tablet, smart phone, or other " +
						"devices.</b>";
						
					if (sReferralUserName != "") {
						sEmailContent += "Just click the link below from within that device. " +
						"Click now to give it a try!<br><br>" +
						"Your UserName is: " + sReferralUserName +
						"<br><font color='#0000FF'><a href=" + sProRefsURL + "><u>" + 
							sProRefsURL + "</u></a></font><br><br>OR"; }
					else {
						sEmailContent += "<br><br>However, it appears you do not have an " +
							"active MissionConnect (Safe Sanctuaries) online account, which " +
							"is required to use this feature. If you receive frequent " +
							"reference requests, and would like an account, please contact " +
							"the MO Safe Sanctuaries office.";
					}
					
					sEmailContent += "<br><br>If you prefer, and you are on a computer, you " +
						"may click the following link to go directly to the reference for " +
						sApplicant + ". This link will not work from mobile devices.<br>" +
						"<font color='#0000FF'><a href=" + sRefURLLink + "><u>" + sRefURLLink + 
						"</u></a></font><br><br>" +
						"Please try to complete this reference within 2 weeks."; 
				break;
			}
				
				return sEmailContent;
		}
	}

})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('passwordStrength', passwordStrength);

	function passwordStrength() {
		var reLowerCase = new RegExp(/([a-z]+)/);
		var reUpperCase = new RegExp(/([A-Z]+)/);
		var reNumber = new RegExp(/([0-9]+)/);
		var reSymbol = new RegExp(/(\W+)/);
		
		var factory = {
			getPWStrength: getPWStrength
		};
		
		return factory;
		
		function getPWStrength(sPassword) {
			var iStrength = 0;
			var sPasswordStrength = "Too Short";
			var sPWClass = "tooShort";
			if (sPassword.length > 8) {
				iStrength++;
				if ((sPassword.search(reLowerCase) != -1) && 
					(sPassword.search(reUpperCase) != -1)) {
						iStrength++;
				}
				if (sPassword.search(reNumber) != -1) {
					iStrength++;
				}
				if (sPassword.search(reSymbol) != -1) {
					iStrength++;
				}
				if (sPassword.length > 11) {
					iStrength++;
				}
				
				switch (iStrength) {
					case 0: 
						sPasswordStrength = "Too Short";
						sPWClass = "tooShort";
					break;
					case 1: 
						sPasswordStrength = "Very Weak";
						sPWClass = "veryWeak";					
					break;
					case 2: 
						sPasswordStrength = "Weak";
						sPWClass = "weak";
					break;
					case 3: 
						sPasswordStrength = "Fair";
						sPWClass = "fair";					
					break;
					case 4: 
						sPasswordStrength = "Strong";
						sPWClass = "strong";					
					break;
					case 5: 
						sPasswordStrength = "Very Strong";
						sPWClass = "veryStrong";					
					break;
				}
			}
			
			return {
				strength: sPasswordStrength,
				class: sPWClass
			}
			
		}
	}
	
})();	 
(function(){
    'use strict';

    angular
		.module('mcweb')
		.factory('modalService', modalService);

	modalService.$inject = ['$uibModal','$log'];

	function modalService($uibModal, $log) {
$log.info("modalService");
		
		var factory = {
            okAlert: openOKAlert,
            resultAlert: openResultAlert
		};
		return factory;
		
		//customize more if need larger...
		function openOKAlert(title, alertMsg) {
			$uibModal.open({
				animation: true,
				size: 'sm',
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: 'static',
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					modType: function() {
						return "OK";
					},
					title: function() {
						return title;
					},
					alertMsg: function() {
						return alertMsg;
					}	
				}
			});
		}
		
		function openResultAlert(sz,result) { //sz:"sm","lg";
			$uibModal.open({
				animation: true,
				size: sz,
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: true,
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					title: function() {						
						return result[0].RESULT;
					},
					alertMsg: function() {
						return result[0].RESULTREASON;
					}
				}
			});
		}
	
	}		
})();	
(function(){
	'use strict';
/**
 * Created by jacob on 6/17/14.
 * SecUserLoginFunctions consolidates SecUserLogin, SecGetReturnCode and UserGetChurchFunctions (which doesn’t apply to all apps, so probably should add a parameter to skip it when not needed)
 */

	angular
		.module('mcweb')
		.factory('loginService', loginService);

	loginService.$inject = ['$http','webSessionStorage','$rootScope','modalService',
		'authServiceCFC','mcWebCFC','custData','$state','$log'];

	function loginService($http, webSessionStorage, $rootScope, modalService,
		authServiceCFC, mcWebCFC, custData, $state, $log) {
		var sDataSource = "";

		var factory = {
			user: {
				USERID: 0,
				loggedIn: false,
				RETURNCODE: "",
				UserChurchFNs: []
			},
			login: login,
			logout: logout,
			secDeleteReturnCode: secDeleteReturnCode,
			secGetReturnCode: secGetReturnCode,
			secReturnLogin: secReturnLogin,
			secReturnReset: secReturnReset
		};
		return factory;
		
		//Return ONLY Functions in UserGetChurchFunctions for MENU:
		function login(username, password) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
			var params = {
				method : "SecUserLoginFunctions",
				sDataSource: sDataSource,
				sUserName: username,
				sPassword: password,
				sApp: "MCWebApps.040",
				iMinutes: 30,
				sFn: "all",
				bFnOnly: 1
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) { $log.info(results)
				if(results.data[0].SECUSERLOGIN[0].RESULT == "Success"){
					setUserInfo(results);
				}
				return results.data;
			});
		}

		function logout() {
			var params = {
				method: "SecDeleteReturnCode",
				sDataSource: sDataSource,
				sReturnCode: factory.user.RETURNCODE
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				if (results.data[0].RESULTS == 'Delete Successful') {
					factory.user.RETURNCODE = "";
				}
				factory.user.loggedIn = false;
			});
		}
		
		function secDeleteReturnCode(retCode) {
			var params = {
				method: "SecDeleteReturnCode",
				sReturnCode: retCode
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
	/* Used from NavBarCtrl to Get returnCode just to transfer to
		different app... then SecUserLoginFunctions is run again from new
		app to set a new ReturnCode to 30 minutes.
		iMin=1, sFn=[app to load]  */
		function secGetReturnCode(iMin,sFn) {
			var params = {
				method: "SecGetReturnCode",
				sDataSource: sDataSource,
				iUserID: factory.user.USERID,
				sApp: "MCWebApps",
				iMinutes: iMin,
				sFn: sFn,
				sParams: ""
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				if (results.data.length > 0) {
					factory.user.RETURNCODE = results.data[0].RETURNCODE;
				}
				return results.data
			});
		}
		
	/* UNABLE TO USE secReturnLogin from AuthService.cfc
		App opened by passing permission from other app...
		Store DatabaseID & FN=$rootScope.goToApp to open.
		Then call regular login with USERNAME/PASSWORD.
		(USERNAME, DATABASEID(sDataSource), APP, FN, USERID, PASSWORD, PARAMS) */	
        function secReturnLogin(sReturnCode) {
            var params = {
                method: "SecReturnLogin",
                sReturnCode: sReturnCode
            };
            return $http.post(mcWebCFC, params)
            .then(function (results) {
				try {
					if (results.data[0].DATABASEID != "") {
						sDataSource = results.data[0].DATABASEID;
					}
				/* User gets logged in, and new ReturnCode created: */	
					secDeleteReturnCode(sReturnCode);
				}
				catch (err) {
				//"TypeError: Cannot read property 'USERID' of undefined"	
					modalService.okAlert("Error", err);
				}	
				return results.data;
			});
		}
        
    /* CALLED When Apps used to extend ReturnCode another 30 minutes (default)
	    before expiration. If expires, user has to Login again for NEW returnCode. */ 
        function secReturnReset(resetCode, iMin) {
			var params = {
				method: "SecReturnReset",
				iUserID: factory.user.USERID,
				sReturnCode: resetCode,
				iNewMinutes: iMin
			};
            return $http.post(mcWebCFC, params)
            .then(function (results) {
                if (results.RESULT == "Expired") {
					factory.user.loggedIn = false;
					modalService.okAlert("Expired",
						"Your session has expired.<br><br>" +
						"Please log in again to continue.");
					$state.go('login', {reload:true});	 
                }
                return results.data;
            });
		}
		
		
/* Internal Utilities: */        
	
		function setUserApplications(arrData) {
			var myApps = [];
			for (var i=0; i<arrData.length; i++) {
				switch (arrData[i].FN) {
					case "ChLeaders":
						if (myApps.length == 0) {
							myApps.push("Local Church Leaders");
						} else {
							for (var j=0; j<myApps.length; j++) {
								if (myApps[j] == "Local Church Leaders") {
								break; }
								else if (j == myApps.length-1) {
									myApps.push("Local Church Leaders");
								break; }
							}
						}
					break;
					case "ChrgAppt":
						//future
					break;
					case "ContactInfo":
						if (myApps.length == 0) {
							myApps.push("Contact Information");	
						} else {
							for (j=0; j<myApps.length; j++) {
								if (myApps[j] == "Contact Information") {
								break; 
								} else if (j == myApps.length-1) {
									myApps.push("Contact Information");
								}
							}
						}
					break;
					case "MinFin":
						if (myApps.length == 0) {
							myApps.push("Ministry Financials");
						} else {
							for (j=0; j<myApps.length; j++) {
								if (myApps[j] == "Ministry Financials") {
								break; }
								else if (j == myApps.length-1) {
									myApps.push("Ministry Financials");		
								}
							}
						}	
					break;
					case "ProRef": case "LCAMgmt":
						for (j=0; j<custData.length; j++) {
							if (custData[j].DataSource == sDataSource) {
								var ProRefApp = custData[j].ProRef;
							break; }
						}
						//Adds Contact Information for ALL Protect “ProRef” or "LCAMgmt" permissions
						if (myApps.length == 0) {
							myApps.push("Contact Information");
							myApps.push(ProRefApp);
						} else {
							for (j=0; j<myApps.length; j++) {
								if (myApps[j] == ProRefApp) {
								break; }
								else if (j == myApps.length-1) {
									myApps.push("Contact Information");
									myApps.push(ProRefApp);
								}
							}
						}	
					break;
					case "SignUp":
						//(future)
					break;
					case "Statistics":
						if (myApps.length == 0) {
							myApps.push("Statistics");
						} else {
							for (j=0; j<myApps.length; j++) {
								if (myApps[j] == "Statistics") {
								break; }
								else if (j == myApps.length-1) {
									myApps.push("Statistics");
								break; }
							}
						}
					break;
				}
			}
			$rootScope.myApps = myApps;
			$rootScope.$broadcast('updateNav');
		}
		
		function setUserInfo (results) {
			factory.user = results.data[0].SECUSERLOGIN[0];
			factory.user.RETURNCODE = results.data[0].SECGETRETURNCODE[0].RETURNCODE;
			//used if refresh browser:
			webSessionStorage.setStoredData('sReturnCode', factory.user.RETURNCODE);
			
			factory.user.loggedIn = true;
			if (results.data[0].USERGETCHURCHFUNCTIONS.length > 0) {
				setUserApplications(results.data[0].USERGETCHURCHFUNCTIONS);
				factory.user.UserChurchFNs = (results.data[0].USERGETCHURCHFUNCTIONS);
			} else {
				factory.user.UserChurchFNs = [];
				$rootScope.$broadcast('updateNav');
			}
		}
		
	}
})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('helpDeskService', helpDeskService);

	helpDeskService.$inject = ['$http','$sce','mcWebCFC','webSessionStorage','$rootScope',
		'version','loginService','modalService','$state'];

	function helpDeskService($http, $sce, mcWebCFC, webSessionStorage, $rootScope,
		version, loginService, modalService, $state) {
		var sDataSource = webSessionStorage.getStoredData('sDataSource');
		
		var service = {
			helpHdInitiateIssue: helpHdInitiateIssue,
			helpHdSaveIssue: helpHdSaveIssue
		};
		return service;
		
		function helpHdInitiateIssue() {
			var params = {
				method: "HelpHdInitiateIssue",
				sReturnType: "json"
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return (results.data);
			});
		}
		
		function helpHdSaveIssue(id, name, email, sProb) {
			if (loginService.user.USERID > 0) {
				var UserID = loginService.user.USERID;
			} else { UserID = -1 }
			var params = {
				method: "HelpHdSaveIssue",
				iIssueID: id,
				sDataSource: sDataSource,
				sApp: "MCWebApps",
				sForm: $rootScope.sCurForm,
				sVersion: version,
				iUserID: UserID,
				sUserFullName: name,
				sUserEmail: email,
				sDatabaseID: webSessionStorage.getStoredData('sDatabaseID'),
				sProblem: sProb
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				if (results.data == "true") {
					$state.go($rootScope.sCurForm);
					modalService.okAlert("Success",
						"Your Help Desk issue has been sent successfully.");
				}
			});
		}
				
	}
	
})();
		

(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('headerService', headerService);
		
	headerService.$inject = ['$rootScope'];
	
	function headerService($rootScope) {
		var headerIcon = { 
			image: "assets/images/MCicon32.png",
			alt: "MissionConnect"};
		
		var service = {
			customer: {name: "MissionConnect"},
			setCustomer: setCustomer,
			getHeaderIcon: getHeaderIcon
		};
			
		return service;
		
		function setCustomer(custName) {
			service.customer.name = custName;
			if (service.customer.name == "MissionConnect") {
				headerIcon = {
					image: "assets/images/MCicon32.png",
					alt: "MissionConnect"
				};
			} else {
				headerIcon = {
					image: "assets/images/crossflameRW_48px.png",
					alt: "UMC Cross and Flame"
				};
			}
			$rootScope.$broadcast('updateCustomer');
		}
				
		function getHeaderIcon() {
			switch (service.customer.name) {
				case "MissionConnect":
					headerIcon = {
						image: "assets/images/MCicon32.png",
						alt: "MissionConnect"
					};
				break;
				default:
					headerIcon = {
						image: "assets/images/crossflameRW_48px.png",
						alt: "UMC Cross and Flame"
					};
				break;
			}
			return headerIcon;
		}
		
	}		
})();	 
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('errorEmailNotification', errorEmailNotification);

	errorEmailNotification.$inject = ['webSessionStorage','$rootScope','loginService'];

	function errorEmailNotification(webSessionStorage, $rootScope, loginService) {
		var sDataSource = webSessionStorage.getStoredData("sDataSource");
		var sEmailContent = "";
		
		var factory = {
			error1: error1,
			error2: error2,
			error3: error3,
			error4: error4
		};
		return factory;
		
		
		function error1(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ReturnCode: " + $rootScope.retCodeKey + "<br>" +
				"User: " + $rootScope.user.USERFULLNAME + "<br>" +
				"UserID: " + $rootScope.user.USERID;
			return sEmailContent;
		}
		
		function error2(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.curProID + "<br>" +
				"Applicant: " + $rootScope.Applicant + "<br>" +
				"User: " + $rootScope.user.USERFULLNAME + "<br>" +
				"UserID: " + $rootScope.user.USERID;
			return sEmailContent;
		}
		
		function error3(sFormProc, iSaveKey) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.curProID + "<br>" +
				"Applicant: " + $rootScope.Applicant + "<br>" +
				"StepSaveKey: " + String(iSaveKey) + "<br>" +
				"User: " + $rootScope.user.USERFULLNAME + "<br>" +
				"UserID: " + $rootScope.user.USERID;
			return sEmailContent;
		}
		
		function error4(sFormProc, resultReason) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"Error: " + resultReason + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
	}

})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('emailValidator', emailValidator);

	function emailValidator() {
		var factory = {
			isValid: isValid
		};
		
		return factory;
		
		function isValid(sEmail) {
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
				
				if (sEmail.search(filter) == -1) {
					return false;
				} else {
					return true;
			}
		}		
	}

})();	 
(function () {
	'use strict';

	angular
		.module('mcweb')
		.factory('datesService', datesService);

	datesService.$inject = [];

	function datesService() {

		var service = {
			calStrToDbDateStr: calStrToDbDateStr,
			currentYear: currentYear,
			get19thBirthDate: get19thBirthDate,
			jsDateStrToCalendarStr: jsDateStrToCalendarStr,
			jsDateStrToDbDateStr: jsDateStrToDbDateStr,
			s1yrFromToday: s1yrFromToday,
			s6mosFromToday: s6mosFromToday,
			s15mosFromToday: s15mosFromToday,
			todayToCalString: todayToCalString,
			todayToDbString: todayToDbString
		};
		return service;
		
		function calStrToDbDateStr(sCal) {
			var dCal = new Date(sCal);
			var mm = dCal.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dCal.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sDbDate = String(dCal.getFullYear()) + "- " + mm + "-" + dd;
			return sDbDate;			// "01/01/2017" ==> "2017-01-01"
		}

		function currentYear() {
			var today = new Date();
			var yr = today.getFullYear();
			return yr; //2017	
		}
		
		function get19thBirthDate(bDay) { // 19th BirthDate as MM/DD/YYYY
			var s19thBDay = "";
			var dt = new Date(bDay);
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			s19thBDay = mm + "/" +  dd + "/" + String(dt.getFullYear()+19);
			return s19thBDay;
		}

		function jsDateStrToCalendarStr(dtStr) {
			var sCalDate = "";
			var dt = new Date(dtStr);
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			sCalDate = mm + "/" + dd + "/" + String(dt.getFullYear()) ;
			return sCalDate; // "August 03, 2017 17:50:20" ==> "08/03/2017"
		}

		function jsDateStrToDbDateStr(dtStr) {
			var sDbDate = "";
			var dt = new Date(dtStr);
			var mm = dt.getMonth()+1;
			var dd = dt.getDate();
			sDbDate = dt.getFullYear() + "-" + mm +	"-" + dd;
			return sDbDate; // // "August 03, 2017 17:50:20" ==> "2017-08-03"
		}
		
		function s1yrFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sCalDate = mm + "/" + dd + "/" + String(today.getFullYear()+1);
			return sCalDate; // today in 2017 as "MM/DD/2018"
		}
		
		function s6mosFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var yr = today.getFullYear();
			var sCalDate = "";
			if (mm < 7) { sCalDate = String(mm+6) + "/" + dd + "/" + yr; }
			else { sCalDate = String((mm+6)-12) + "/" + dd + "/" + String(yr+1); }
			return sCalDate; // today= 7/1/2017 ==> "01/01/2018"
		}
		
		function s15mosFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var yr = Number(today.getFullYear())+1;
			var sCalDate = "";
			if (mm < 10) { sCalDate = String(mm+3) + "/" + dd + "/" + yr; }
			else { sCalDate = String((mm+3)-12) + "/" + dd + "/" + String(yr+1); }
			return sCalDate; // today= 10/1/2017 ==> "01/01/2019"
		}
		
		function todayToCalString() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			var sCalToday = mm + "/" + dd + "/" + String(today.getFullYear()) ;
			return sCalToday;	// today as "MM/DD/YYYY"
		}
		
		function todayToDbString() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			var sDbToday = String(today.getFullYear()) + "-" + mm + "-" + dd;
			return sDbToday;	// today as "YYYY-MM-DD"
		}

	}
})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('dataService', dataService);

	dataService.$inject = ['$http','$sce','webSessionStorage','mcWebCFC','proJsCFC','loginService'];

	function dataService($http, $sce, webSessionStorage, mcWebCFC, proJsCFC, loginService) {
		var sDataSource = "";
		
		var service = {
			setDataSource: setDataSource,
			addrGetAll: addrGetAll,
			chLoadAll: chLoadAll,
			emailSendCustom: emailSendCustom,
			emailSendError: emailSendError,
			emGetAll: emGetAll,
			libGetMaintenanceMsg: libGetMaintenanceMsg,
			peoGetByEmail: peoGetByEmail,
			peoGetForChurch: peoGetForChurch,
			peoSave: peoSave,
			phGetAll: phGetAll,
			proGetForm: proGetForm,
			proSaveFormData: proSaveFormData,
			proSaveMain: proSaveMain,
			proSaveProcess: proSaveProcess,
			sendForgottenPassword: sendForgottenPassword,
			usersChangePassword: usersChangePassword,
			usersGetOne: usersGetOne,
			usersSave: usersSave
		};
		return service;
		
		function setDataSource() {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		}
		
		function addrGetAll(iEntityID) {
			var params = {
				method: "AddrGetAll",
				sDataSource: sDataSource,
				iEntityID: iEntityID
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function chLoadAll(sChurchName) {
			var params = {
				method: "ChLoadAll",
				sDataSource: sDataSource,
				sChurchName: sChurchName
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				resetReturnCode();
				return results.data;
			});
		}

		function emailSendCustom(sEmailAddr, sFrom, sReplyTo, sSubject, sEmailContent) {
			var params = {
				method: "EmailSendCustom",
				sEmailAddr: sEmailAddr,
				sFrom: sFrom,
				sReplyTo: sReplyTo,
				sSubject: sSubject,
				sEmailContent: sEmailContent
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function emailSendError(sEmailContent) {
			var params = {
				method: "EmailSendCustom",
				sEmailAddr: "errors@greatspirit.com",
				sFrom: "GSS Error-Notification <errors@greatspirit.com",
				sReplyTo: "errors@greatspirit.com",
				sSubject: "MCWebApps Error",
				sEmailContent: sEmailContent
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function emGetAll(iEntityID) {
			var params = {
				method: "EmGetAll",
				sDataSource: sDataSource,
				iEntityID: iEntityID
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function libGetMaintenanceMsg() {
			var params= {
				method: "LibGetMaintenanceMsg"
			};
			return $http.post(mcWebCFC, params)
			.then(function (result) {
				return result.data;
			});
		}
		
		function peoGetByEmail(email) {
			var params = {
				method: "PeoGetByEmail",
				sDataSource: sDataSource,
				sEmail: email
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				resetReturnCode();
				return results.data;
			});
		}

		function peoGetForChurch(last,first) {
			var params = {
				method: "PeoGetForChurch",
				sDataSource: sDataSource,
				sLastName: last,
				sFirstName: first,
				sIncludeLockedApps: "LCProtect|MCProtect|WebProtect",
				bSearchFromBeginning: 1,
				sFn: "ContactInfo",
				iUserID: loginService.user.USERID
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				resetReturnCode();
				return results.data;
			});
		}
		
		function peoSave(sSaveString) {
			var params = {
				method: "PeoSave",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function phGetAll(iEntityID) {
			var params = {
				method: "PhGetAll",
				sDataSource: sDataSource,
				iEntityID: iEntityID
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function proGetForm(sFormName) {
			var params = {
                method: "ProGetForm",
                sDataSource: sDataSource,
                sFormType: "WebProtect",
                sFormName: sFormName
            };
            return $http.post(mcWebCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function proSaveFormData(sSaveString) {
			var params = {
				method: "ProSaveFormData",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proSaveMain(sSaveString) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "ProSaveMain",
				sDataSource: sDataSource,
				sRawDataString: sSaveString	
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			})
		}
		
		function proSaveProcess(sSaveString) {
			var params = {
				method: "ProSaveProcess",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function sendForgottenPassword(sUserName) {
			var params = {
				method: "SendForgottenPassword",
				sDataSource: sDataSource,
				sUserName: sUserName,
				sCustomEmailText: ""
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function usersChangePassword(sSaveString) {
			var params = {
				method: "UsersChangePassword",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function usersGetOne(iUserID) {
			var params = {
				method: "UsersGetOne",
				sDataSource: sDataSource,
				iUserID: iUserID
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function usersSave(sSaveString) {
			var params = {
				method: "UsersSave",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				resetReturnCode();
				return results.data;
			});
		}
		

//Internally called functions:
		
		function resetReturnCode() {
			loginService.secReturnReset(loginService.user.RETURNCODE, 30);
		}
		
	}
})();
 
 
(function () {
    'use strict';
 
	angular
        .module('mcweb')
        .factory('contactInfo', contactInfo);

	contactInfo.$inject = ['$http','webSessionStorage','dataService','datesService','proJsCFC'];	

    function contactInfo($http, webSessionStorage, dataService, datesService, proJsCFC) {
		var sDataSource = "";
		
		var factory = {
			savePersonalEmail: savePersonalEmail
		};
		
		return factory;	
	

//EMAILS:

		//Specifically for NEW accounts where initial email is Primary:
		function savePersonalEmail(iEntityID, sEmail) {
			if (sDataSource == "") { setDataSource(); }
			var iPersonalEmailType = 0;
			var sDbToday = datesService.todayToDbString();
			
			//Get Email Types:
			var params1 = {
				method: "EmLoadTypes",
				sDataSource: sDataSource
			};
			return $http.post(proJsCFC, params1)
			.then(function(emTypes) {
				var arrTypes = emTypes.data;
				
				for (var j=0; j<arrTypes.length; j++) {
					if (arrTypes[j].EMAILTYPE == "Personal") {
						iPersonalEmailType = arrTypes[j].EMAILTYPEID;
					break; }
				}
				
				var sRawDataString = "MCWebApps || NewAccount_Em || -11 || I || EntityID==" + iEntityID + 
					" || EmailTypeID==" + iPersonalEmailType + " || Email==" + sEmail + 
					" || StartDate==" + sDbToday + 
					" || PrimaryEmail==1 || RcvEmailComm==1 || Privacy==Public ^^ ";
					
				var params = {
					method: "EmSave",
					sDataSource: sDataSource,
					sRawDataString: sRawDataString 
				};
				return $http.post(proJsCFC, params)
				.then(function (results) {
					return results.data;
				});
			});
		}
		
		
//Internally called functons:
		function setDataSource() {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		}
		
	}
})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('confirmPWChg', confirmPWChg);
		
	function confirmPWChg() {
		var factory = {
			confirmEmail: confirmEmail,
			confirmPassword: confirmPassword,
			notReadyToSave: notReadyToSave
		};
		return factory;
		
		function confirmEmail(sNewEmail, sConfirmEmail) {
			var strEmail;
			if (sNewEmail != "" && sConfirmEmail != "") {
				if (sNewEmail.toLowerCase() == sConfirmEmail.toLowerCase()) {
					strEmail = "true"; }
				else {
					strEmail = "The New Email and the Confirmed Email addresses do not match. " +
						"Please enter the Email addresses again."; 
				}
			} else {
				strEmail = "false";
			}
			return strEmail;
		}
				
		function confirmPassword(sNewPW, sConfirmPW) {
			var strPW;
			if (sNewPW != "" && sConfirmPW != "") {
				if (sNewPW == sConfirmPW) { strPW = "true"; }
				else {
					strPW = "The New Password and the Confirmed Password do not match. " +
						"Please enter the passwords again."; 
				}
			} else {
				strPW = "false";
			}
			return strPW;
		}
		
		//click Save button when NOT activated, so tell user why...
		function notReadyToSave(sOldPW, sNewPW, sConfirmPW, sNewEmail, sConfirmEmail) {
			var str = "";
			if (sOldPW == "" && sNewPW == sConfirmPW) {
				str = "It is required that you enter your old password " +
					"in order to Save a new one."; }
			else if ((sNewEmail != "" || sConfirmEmail != "") &&
				sNewEmail.length != sConfirmEmail.length) {
				str = "You must enter the new Email Address twice, and the " +
					"entries must match, in order to save a new Email.\n\n" +
					"Please be sure you are entering the same address in " +
					"both the New and Confirm Email Address fields."; }
			else if ((sNewPW != "" || sConfirmPW != "") &&
				sNewPW.length != sConfirmPW.length) {
				str = "You must enter the new Password twice, and the \n" +
					"entries must match, in order to save a new Password.\n\n" +
					"Please be sure you are entering the same password in " +
					"both the New and Confirm Password fields."; }	
			else if (sOldPW == "" && sNewPW == "" && sConfirmPW == "" &&
				sNewEmail == "" && sConfirmEmail == "") {
				str = "There is nothing to Save! \n\n" +
					"Please enter your new Password or Email before " +
					"clicking the Save button.";	
			}
			return str;
		}
	}

})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.factory('confirmEmailChg', confirmEmailChg);
		
	confirmEmailChg.$inject = ['$window','emailValidator'];
	
	function confirmEmailChg($window, emailValidator) {
		var factory = {
			confirmEmail: confirmEmail
		};
		return factory;
		
		function confirmEmail(sNewEmail, sConfirmEmail) {
			var strEmail;
			if (sNewEmail != "" && sConfirmEmail != "") {
				if (sNewEmail.toLowerCase() == sConfirmEmail.toLowerCase()) {
					if (emailValidator.isValid(sNewEmail) == true) {
						strEmail = "true"; }
					else {
						strEmail = "false";
						$window.alert("The email entered is not a valid email address. " +
							"Please enter a valid email address.");
					}	
				} else {
					strEmail = "noMatch";
					$window.alert("The Email and the Confirmed Email addresses do not match. " +
						"Please enter the Email addresses again."); }
			} else { 
				strEmail = "false"; 
			}
			return strEmail;
		}
						
	}

})();
(function () {
    'use strict';
 
	angular
        .module('mcweb')
        .factory('appValidationService', appValidationService);

	appValidationService.$inject = ['loginService','modalService'];	

    function appValidationService(loginService, modalService) {
		var service = {
			validateAccess: validateAccess
		};
		
		return service;
		
		function validateAccess() {
			var apps = loginService.user.UserChurchFNs;
			var perm = "Denied";
			if (apps.length > 0) {
				for (var i=0; i<apps.length; i++) { 
					if (apps[i].FN == "ContactInfo") {
						perm = "Valid";
					break; }
					else if (i == apps.length-1) {
						if (apps.length == 1) {
							perm = apps[0].FN;
						} else {
							perm = "MultApps";
						}
					}	
				}	
			} else {
				modalService.okAlert("Account Access Denied", 
					"This account does not have access to any MissionConnect online " +
					"applications at this time.<br><br>Please contact your Conference " +
					"Administrator to request access.");
			}
			
			return perm; //Valid, Denied, MultApps, or an App FN.	
		}	
	}
})();
(function () {
	'use strict';
 
	angular
		.module('mcweb')
		.directive('dirEnterKey', dirEnterKey);
	
	function dirEnterKey($event) {
		
		return function($scope, attrs) {
			var keyCode = $event.keyCode;
			if (keyCode === 13) {
				$scope.$apply(function() {
					$scope.$eval(attrs.dirEnterKey);
				});
				event.preventDefault();
			}
		}
	}
	
})();	


(function() {
	'use strict';

	angular
		.module('mcweb')
		.config(function($httpProvider) {
			$httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'; 

			// Override $http service's default transformRequest 
			$httpProvider.defaults.transformRequest = [function(data) { 
				/* The workhorse; converts an object to x-www-form-urlencoded serialization. * @param {Object} obj * @return {String} */ 
				var param = function(obj) { 
					var query = ''; 
					var name, value, fullSubName, subName, subValue, innerObj, i; 
					for(name in obj) { 
						value = obj[name]; 
						if(value instanceof Array) { 
							for(i=0; i<value.length; ++i) { 
								subValue = value[i]; 
								fullSubName = name + '[' + i + ']'; 
								innerObj = {}; 
								innerObj[fullSubName] = subValue; 
								query += param(innerObj) + '&'; 
							} 
						} 
						else if(value instanceof Object) { 
							for(subName in value) { 
								subValue = value[subName]; 
								fullSubName = name + '[' + subName + ']'; 
								innerObj = {}; 
								innerObj[fullSubName] = subValue; 
								query += param(innerObj) + '&'; 
							}
						}//ln35: was "undefined"
						else if(value !== angular.isUndefined && value !== null) { 
							query += encodeURIComponent(name) + '=' + 
							encodeURIComponent(value) + '&'; 
						}
					}
					return query.length ? query.substr(0, query.length - 1) : query; 
				}; 
				return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
			}];
		});
})();
/* 

AppName - [Description]
	Programmer: Lori D Smith
	1.000.000 - release
	1.000.036 - very minor tweak... no backup needed.

GLOBALS:
	sessionStorage:
		sDataSource
		sDatabaseID
		//sCustomer - not needed... stays once set, can look up again to reset.

	loginService:
		.user {
			USEREMAIL,				==> chgPWCtrl
			USERID,					==> dataService
			USERFULLNAME,			==> 
			USERENTITYID			==> 
			RETURNCODE				==> 
			RETURNKEY
			firstName				==> 
			lastName				==> 
			loggedIn
			UserChurchFNs			==> populated with USERGETCHURCHFUNCTIONS return
		};

	$rootScope
		.loggedIn		while successfully logged In.
		.myApps			(navBarCtrl) to load Apps into MENU Secure Applications.
		.sCurForm		last form accessed, for HelpDesk assistance.
		.selEntityID;	Selected person for view of ContactInfo. Stored to return as 
							selected if 2 with same name in list.
		.
	
COLORS:
	#000		black
	#333		light black
	#555		dark gray
	#f5f5f5		light gray for buttons
	#E8C944		MC Gold 100%
	#6B9AAE		MC Blue 50%
	#AEB9C6		MC Blue 35%	
	
	LOCAL PATH:  cd Applications/ColdFusion9/wwwroot/Burt/Falcon/Web_TestSite/mcweb
	TESTING PATH: 
	
	Prior to release:
		* index.module
			
		* index.constants
			
		* loginCtrl
			
			
			
	Release Path: https://umcdata.net/MissionConnect/Public/MCWebApps/#/index.html opt:(?conf=MO)		

*/	
angular
	.module('mcweb')
	.filter('fZipcode', fZipcode);
	
function fZipcode() {
	return function (zip) {
		if (!zip) {
			return zip;
		} else {
			if (zip.toString().length === 9) {
				return zip.toString().slice(0,5) + "-" + zip.toString().slice(5);
			} else if (zip.toString().length === 5) {
				return zip.toString();
			} else {
				return zip;
			}
		}
	}	
}
angular
	.module('mcweb')
	.filter('fPhone', fPhone);

//Called directly from the view for display
	
function fPhone() {
	return function (input) {
		if (!input) {
			return input;
		} else {
			var value = input.toString().trim().replace(/^\+/, '');
			if (value.match(/[^0-9]/)) {
				return input;
			}
			
			var country = 0;
			var areaCode, number;
			
			switch (value.length) {
				case 10: // (###) ###-####
					country = 1;
					areaCode = value.substr(0,3);
					number = value.slice(3);
				break;
				case 11: // Foreign
					country = value[0];
					areaCode = value.substring(1,4);
					number = value.slice(4);
				break;
				case 12: // Foreign
					country = value.substring(0,3);
					areaCode = value.substring(3,5);
					number = value.slice(5);
				break;
			}
			
			if (country.value == 0) {
				return input;
			} else {
				if (country == 1) {
					country = "";
				}
				number = number.substring(0,3) + "-" + number.slice(3);

				return (country + " (" + areaCode + ") " + number).trim();
			}
		}
	}	
}
angular
    .module('mcweb')
    .controller('NewAcctController', NewAcctController);

NewAcctController.$inject = ['$rootScope','$state', '$window', 'passwordStrength',
	'confirmEmailChg', 'dataService','loginService','contactInfo','datesService',
	'webSessionStorage','userAcctEmails','errorEmailNotification','protectURL','$log'];	

function NewAcctController($rootScope, $state, $window, passwordStrength,
	confirmEmailChg, dataService, loginService, contactInfo, datesService, 
	webSessionStorage, userAcctEmails, errorEmailNotification, protectURL, $log) {
	var vm = this;	//vmUA
    
    vm.bReadyToSave = 'false';
    vm.bReadyToSaveEmail = false;
    vm.bReadyToSavePW = false;
    vm.bReadyToSaveUsername = false;
    vm.imgMCBanner = { image: "assets/images/Mc_Banner978x75.png" };
    vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
    vm.sPasswordStrength = "Too Short";
    vm.sProID = "";							//ONLY used in McCurdy Protect Initialization with New Account.
    vm.sPWClass = "tooShort";
    vm.sSaveSuccessMsg = "";
    
    vm.data = {
		firstName:"", lastName:"",
		password:"", confirmPW:"",
		email:"", confirmEmail:"",
		userName:""};					
	vm.iEntityID = 0;
	vm.iUserID = 0;
    
    
    function validateEmail() {
		var emValidate = confirmEmailChg.confirmEmail(vm.data.email, vm.data.confirmEmail);
		switch (emValidate) {
			case "true": 
				vm.bReadyToSaveEmail = true;
			break;
			case "noMatch":
				vm.bReadyToSaveEmail = false;
				vm.data.confirmEmail = "";
			break;
			case "false": //returned when one or other is ""
				vm.bReadyToSaveEmail = false;
			break;
		}
    }
    
    function validatePW() {
		if (vm.data.password != "" && vm.data.confirmPW != "") {
			if (vm.data.password == vm.data.confirmPW) {
				if (vm.sPasswordStrength == "Strong" ||
					vm.sPasswordStrength == "Very Strong") {
					vm.bReadyToSavePW = true; 
				} else {
					vm.bReadyToSavePW = false;
					vm.data.confirmPW = "";
					$window.alert("The password needs to meet the \"Strong\"\n" +
						"or \"Very Strong\" validation before it can be saved.");
				}
			} else {
				$window.alert("The entered Password and the Confirmed " +
					"Password do not match. Please enter the confirmed password again.");
				vm.data.confirmPW = "";
				vm.bReadyToSavePW = false;
			}	
		} else { vm.bReadyToSavePW = false; }
    }
    
    function validateUserName() {
		var un = vm.data.userName;
		if (un != "") {
			if (un.indexOf("'") != -1) {
				$window.alert("The User Name cannot contain an apostrophe ('). Please remove " +
					"the apostrophe from the User Name entry.");
				vm.bReadyToSaveUsername = false;	
			} else if (un.indexOf("gss") != -1) {
				$window.alert("The prefix of 'gss' is reserved for authorized Great Spirit Systems " +
					"staff only. Please use different characters for the first 3 positions in your " +
					"User Name.");
				vm.bReadyToSaveUsername = false;	
			} else if (un.length < 4) {
				$window.alert("The User Name must be at least 4 characters in length.");
				vm.bReadyToSaveUsername = false;
			}
			else { vm.bReadyToSaveUsername = true; }
		} else { vm.bReadyToSaveUsername = false; }	
    }
			
    function saveNewPersonRecord() {
		var fn = vm.data.firstName.toLowerCase();
		var fName = fn.substr(0,1).toUpperCase() + fn.slice(1);
		vm.data.firstName = fName;
		var ln = vm.data.lastName.toLowerCase();
		var lName = ln.substr(0,1).toUpperCase() + ln.slice(1);
		vm.data.lastName = lName;
		var sRawDataString = "MCWebApps || NewAccount_PR || -10 || I || FirstName==" + fName +
			" || LastName==" + lName + " || ClergyLay==L || AppName==WebProtect || Locked==-1 ^^ ";
$log.info("savePeo:",sRawDataString)
		dataService.peoSave(sRawDataString)
		.then(function (result) {
			if (result[0].RESULTCODE == "Success") {
				var idx = result[0].RESULTREASON.indexOf("EntityID=");
				vm.iEntityID = Number(result[0].RESULTREASON.slice(idx+9));
				saveContactEmail();
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/peoSave",
					result[0].RESULTREASON);
				dataService.emailSendError(sEmailContent);
			}
		});
    }
    
    function saveContactEmail() {  $log.info("SaveContactEmail...")
		contactInfo.savePersonalEmail(vm.iEntityID,vm.data.email)
		.then(function(result) {
			if (result[0].RESULTCODE == "Success") {
				saveUserAccount();
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveContactEmail",
					result[0].RESULTREASON);
				dataService.emailSendError(sEmailContent);
			}
		});
	}	
		
	function saveUserAccount() { $log.info("saveUserAccount...")	
		var pwExpires = datesService.s15mosFromToday();
		var sSaveString = "MCWebApps || NewAccount_UA || -12 || I || UserName==" +
			vm.data.userName + " || UserFullName==" + vm.data.firstName + " " + vm.data.lastName +
			" || UserDesc==Public User || Active==1 || Admin==0 || Password==" + vm.data.password +
			" || PasswordExpires==" + pwExpires + " || PWStrength==" + vm.sPasswordStrength + 
			" || UserEmail==" + vm.data.email + " || UserEntityID==" + vm.iEntityID + " || UserLevel==2 ^^ ";
		
		dataService.usersSave(sSaveString)
		.then(function(result) { $log.info(result)
            if (result[0].RESULTCODE == "Success") {
				//found bug of "." after UserID, so have to detect length,
				//and remove 1 character to get actual UserID.
				var idx = result[0].RESULTREASON.indexOf("UserID=");
				var len = result[0].RESULTREASON.length;
				vm.iUserID = result[0].RESULTREASON.substring(idx+7,len-1);

				switch (vm.sDatabaseID) {
					case "MC": case "MC-DEV":
						var sRawDataString = "MCWebApps || NewAcct_ProMain || " + vm.iUserID + 
							" || I || EntityID==" + vm.iEntityID + " || CertTypeID==4 ^^ ";
$log.info(sRawDataString);
						dataService.proSaveMain(sRawDataString)
						.then(function(result) { $log.info("ProMain:",result)
							if (result[0].RESULTCODE == "Success") {
								idx = result[0].RESULTREASON.indexOf("ProID=");
								vm.sProID = result[0].RESULTREASON.slice(idx+6);
								saveProProcessRecord();	
							}	
						});
					break;
					default:
						sendNewUserAcctEmail();
					break;
				}
			} else {
				if (result[0].RESULTREASON.indexOf("UserName") == 0 &&
					result[0].RESULTREASON.indexOf("already in use") > 0) {
					vm.data.userName = "";
					$window.alert(result[0].RESULTREASON + 
						"\nPlease try entering another unique User Name.");
				} else {	
					var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveUserAccount",
						result[0].RESULTREASON);
					dataService.emailSendError(sEmailContent);
				}	
			}
		});
    }
    
	//McCurdy ONLY... as ONLY Protect app in use!
	function saveProProcessRecord() {
		var dStepExpires = datesService.s6mosFromToday();
		var sDbToday = datesService.todayToDbString();

		var sRawDataString = "MCWebApps || NewAcct_ProProcess || " + vm.iUserID +
			" || I || ProID==" + vm.sProID + " || StepID==400 || StepDate==" + sDbToday + 
			" || StepNote==Initialized by " + vm.data.firstName + " " + vm.data.lastName + 
			" ^^ I || ProID==" + vm.sProID + " || StepID==401 || StepExpires==" + 
			dStepExpires + " ^^ ";
		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) { $log.info("ProProcess:,",result)
			if(result[0].RESULTCODE == 'Success') {
				proSaveInitData();
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveProProcessRecord",
					result[0].RESULTREASON);
				dataService.emailSendError(sEmailContent);
			}
		});
    }

	//McCurdy ONLY... save initial Protect data...
	function proSaveInitData() {
		var sRawDataString = "MCWebApps || NewAcct_ProData || " + vm.iUserID + " || ";

		dataService.proGetForm("Application")
		.then(function(defs) {
			if (defs.length > 0) {
				for (var i=0; i<defs.length; i++) {
					switch (defs[i].ITEMNAME) {
						case "FirstName":
							sRawDataString += "I || ProID==" + vm.sProID + " || ItemID==" +
								defs[i].ITEMID + " || ItemData==" + vm.data.firstName + " ^^ ";
						break;
						case "LastName":
							sRawDataString += "I || ProID==" + vm.sProID + " || ItemID==" +
								defs[i].ITEMID + " || ItemData==" + vm.data.lastName + " ^^ ";
						break;
						case "Email":
							sRawDataString += "I || ProID==" + vm.sProID + " || ItemID==" +
								defs[i].ITEMID + " || ItemData==" + vm.data.email + " ^^ ";
						break;
					}
				}
				
				dataService.proSaveFormData(sRawDataString)
				.then(function(results) {
					if(results[0].RESULTCODE != 'Success') {
						var sEmailContent = errorEmailNotification.error4("newAcctCtrl/proSaveInitData",
							results[0].RESULTREASON);
						dataService.emailSendError(sEmailContent);
					} else {
						sendNewUserAcctEmail();
					}
				});
			}
		});
	}
	
	function sendNewUserAcctEmail() {
		userAcctEmails.sendSelfInitUAEmail(vm.data.userName, vm.data.email)
		.then(function(result) {
			if (result == "Completed") {
				//login
				loginService.login(vm.data.userName, vm.data.password)
				.then(function(loginReturn) {
					if (loginReturn[0].SECUSERLOGIN[0].RESULT == "Success") {
						switch (vm.sDatabaseID) {
							case "MC": case "MC-DEV":
							case "NWTX": case "NWTX-DEV":
								loginService.secReturnReset(loginService.user.RETURNCODE, 1)
								.then(function(result) {
									if (result[0].RESULT == "Success") {
										$window.location.replace(protectURL +
											"?ReturnCode="+loginService.user.RETURNCODE);
									} else { //Expired Session
										$window.alert("Your session has expired. Please log in again.");
										$state.go('login', {reload:true});	
									}
								});
							break;
							default:
								loginService.user.USERENTITYID = 
									loginReturn[0].SECUSERLOGIN[0].USERENTITYID;
								$rootScope.sCurForm = "contactInfo";
								$state.go('contactInfo');
							break;	
						}
					}
				});
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/proSaveInitData",
					result);
				dataService.emailSendError(sEmailContent);
			}
		});
	}
    
    
/* Externally Called Functions: */
    vm.cancelChanges = function() {
		$state.go('login');    	
	};
    
    vm.checkPWStrength = function() {
		var pwReturn = passwordStrength.getPWStrength(vm.data.password);
		vm.sPasswordStrength = pwReturn.strength;
		vm.sPWClass = pwReturn.class;
	};  

    vm.confirmReadyToSave = function(item) {
		switch (item) {
			case "email":
				validateEmail();	
			break;
			case "pw":
				validatePW();
			break;
			case "username":
				validateUserName();
			break;
		}		
		if (vm.bReadyToSavePW == true && vm.bReadyToSaveEmail == true &&
			vm.bReadyToSaveUsername == true && vm.data.firstName != "" &&
			vm.data.lastName != "") {
			vm.bReadyToSave = 'true'; }
		else { vm.bReadyToSave = 'false'; }
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.bReadyToSave == "true") {
				//openCaptcha() *** ADD after Conference!
				saveNewPersonRecord();
			}
		}		
	};
	
	vm.saveNewAccount = function() { $log.info(vm.bReadyToSave, vm.bReadyToSaveUsername, vm.bReadyToSaveEmail)
	//Validation that Email/Password confirmations match already done.
		if (vm.bReadyToSave == "true") {
			saveNewPersonRecord(); 
		} else if (vm.bReadyToSaveUsername == false) {
			validateUserName();
		} else if (vm.bReadyToSavePW == false) {
			validatePW();
		} else if (vm.bReadyToSaveEmail == false) {
			validateEmail();
		}
    };
    
}
angular		
	.module('mcweb')
	.controller('NavBarController', NavBarController);

NavBarController.$inject = ['$state','webSessionStorage','headerService','$scope','modalService',
	'$rootScope', 'loginService','version','lclURL','protectURL','statsURL','minFinURL','$window'];
	
function NavBarController($state, webSessionStorage, headerService, $scope, modalService,
	$rootScope, loginService, version, lclURL, protectURL, statsURL, minFinURL, $window) {
	var vm = this;

	vm.appBarColor = "#CCC";
	vm.headerIcon = headerService.getHeaderIcon();
	vm.isCollapsed = true;
	vm.loggedIn = false;
	vm.myApps = [];
	vm.sCustomerName = headerService.customer.name;//getCustomerName();
	vm.version = version;
	
	
/* Broadcasts: */	 
	$scope.$on('closeMenu', function() {
		vm.isCollapsed = true;
	});
	
	$scope.$on('updateCustomer', function() {
		vm.headerIcon = headerService.getHeaderIcon();
		vm.sCustomerName = headerService.customer.name;
		if (vm.loggedIn) { vm.appBarColor = "#E8C944"; }
		else { vm.appBarColor = "#CCC"; }
	});
	
	$scope.$on('updateNav', function() {
		vm.myApps = $rootScope.myApps; 
		vm.loggedIn = loginService.user.loggedIn;
		if (vm.loggedIn) { vm.appBarColor = "#E8C944"; }
		else { vm.appBarColor = "#CCC"; }
	});

	
/* Calls from View: */

	vm.goHome = function() {
		$state.go('login', {reload:true});
	};
	
	vm.goToAbout = function() {
		$rootScope.sCurForm = "about";
		$state.go('about');
	};
	
	vm.goToApp = function(app) {
		if ($rootScope.bPasswordExpired == true) {
				modalService.okAlert("Password Expired",
				"Your current password has expired.<br>" +
				"You must create a new password to continue.");
			$state.go('chgPW');	
		} else {
			var sFn = "";
			var sPath = "";
			switch (app) {
				case "Contact Information":
					sFn = "ContactInfo";
					$rootScope.sCurForm = "Contact Information";
				break;
				case "Local Church Leaders":
					sFn = "ChLeaders";
					sPath = lclURL
				break;
				case "Ministry Financials":
					sFn = "MinFin";
					sPath = minFinURL;
				break;
				case "Safe Sanctuary References": 	//MO
				case "Volunteer References":		//NWTX
				case "Protect References":			//DEFAULT
					sFn = "ProRef";
					sPath = protectURL;
				break;
				case "Statistics":
					sFn = "Statistics";
					sPath = statsURL;
				break;
			}
	
		/* Validate ReturnCode, resetting to expire in 1 minute...
			Call for NEW ReturnCode set to expire in 1 minute...
			And go to new app (sFn), which will login to new app and issue new ReturnCode
			for session in new app.  */	
			switch (sFn) {
				case "ContactInfo": //local path
					loginService.secReturnReset(loginService.user.RETURNCODE, 30);
					$state.go('contactInfo');								
				break;
				default: //external to this app:
					loginService.secReturnReset(loginService.user.RETURNCODE, 1)
					.then(function(result) {
						if (result[0].RESULT == "Success") {
							$window.location.replace(sPath + "?ReturnCode=" +
								loginService.user.RETURNCODE);
						} else { //Expired Session
							modalService.okAlert("Expired",
								"Your session has expired. Please log in again, " + 
								"then select the application desired.");
							$state.go('login', {reload:true});	
						}		 
					});
				break;
			}
		}	
	}; //goToApp()
	
	vm.goToChgPW = function() {
		$rootScope.sCurForm = "chgPW";
		$state.go('chgPW');
	};
	
	vm.goToHelpDesk = function() {
		$state.go('helpDesk', {reload:true});
	};
	
/** Deletes the active ReturnCode, removes all secure apps,
	sends user back to login screen, selected Customer retained: */	
	vm.logOff = function() {
		vm.loggedIn = false;
		loginService.logout();
		loginService.user = {};
		$rootScope.myApps = [];
		vm.myApps = [];
		$state.go('login', {reload:true});
	};
	
}	 

angular
    .module('mcweb')
    .controller('ModalController', ModalController);

ModalController.$inject = ['$uibModalInstance','modType','title','alertMsg',
	'dataService','datesService','$sce'];

function ModalController($uibModalInstance, modType, title, alertMsg, 
	dataService, datesService, $sce) {
    var vm = this;
    
    vm.modType = modType;	//OK, printOpts, etc...
    vm.sTitle = title;
    vm.sAlertMsg = $sce.trustAsHtml(alertMsg);

	vm.cancel = function() {
		$uibModalInstance.dismiss();
	};

}

angular
	.module('mcweb')
	.controller('LoginController', LoginController);

LoginController.$inject = ['webSessionStorage','$rootScope','dataService','$state','$window',
	'loginService','modalService','custData','headerService','appValidationService',
	'setCustService','custDataDev','protectURL','statsURL','minFinURL','lclURL','$sce','$log'];

function LoginController(webSessionStorage, $rootScope, dataService, $state, $window,
	loginService, modalService, custData, headerService, appValidationService, 
	setCustService, custDataDev, protectURL, statsURL, minFinURL, lclURL, $sce, $log) {
	var vm = this; //as vmLI
	
	vm.custDB = custData;
	vm.selConf = custData[0];
	vm.sMaintenanceMsg = '';
	vm.sUsername = "";
	vm.sPassword = "";
	

//INITIALIZE:	

	$rootScope.sCurForm = 'Login';
$log.info($rootScope.sCurForm);
	
	//If timed out, preset conference to stored conf:
	if (angular.isDefined(headerService.customer)==true) {
		if (headerService.customer.name != "MissionConnect") {
			updateSelCust();
		}
	}
	
	/* Display MaintenanceMsg: */
	dataService.libGetMaintenanceMsg()
	.then(function(msg) { $log.info('msg:', msg);
		if (msg.length > 0) {
			vm.sMaintenanceMsg = $sce.trustAsHtml(msg[0].SETTINGVALUE);
		}
	});

	
	function logInUser() {
		loginService.login(vm.sUsername, vm.sPassword)
		.then(function(data) {
			if (data[0].SECUSERLOGIN[0].RESULT == "Success") {
				var sExp = data[0].SECUSERLOGIN[0].PASSWORDEXPIRES;
				var dPasswordExpires = new Date(sExp.substr(0,4),
					Number(sExp.substr(5,2))-1, sExp.substr(8,2));
				var dToday = new Date();
				if (dPasswordExpires > dToday) {

				/* Determine landing page... */
					var permission = appValidationService.validateAccess();
					if (permission == "Valid") {
						$rootScope.sCurForm = 'Contact Information';
						$state.go('contactInfo');
					} else if (permission == "MultApps") {
						$state.go('selApp');
					} else if (permission != "Denied") { 
						var sPath = "";
						switch(permission) {
							case "ChLeaders": sPath = lclURL; break;
							case "MinFin": sPath = minFinURL; break;
							case "ProRef":
							case "LCAMgmt": sPath = protectURL; break;
							case "Statistics": sPath = statsURL; break;
						}
						if (sPath != "") {
							loginService.secReturnReset(loginService.user.RETURNCODE, 1)
							.then(function(result) {
								if (result[0].RESULT == "Success") {
									$window.location.replace(sPath+"?ReturnCode=" +
										loginService.user.RETURNCODE);
								}
							});
						}
					} else {
						$rootScope.sCurForm = 'Login';
						$state.go('login'); 
					}
				} else {
					$rootScope.bPasswordExpired = true;
					modalService.okAlert("Expired Password",
						"Your current password has expired.\n" +
						"You must create a new password to continue.");
					$state.go('chgPW');
				}
			} else if (data[0].SECUSERLOGIN[0].RESULT == "Fail") {
				modalService.okAlert("Login Failed",
					"We were unable to log you in with the Username and Password provided.<br><br>" +
					"Please try again, or have your password sent to you by clicking the \"Forgot " +
					"Password\" button.");
			}
		});
	}
	
	function updateSelCust() {
		var sDataSource = webSessionStorage.getStoredData("sDataSource");
		if (sDataSource.slice(-3) == "Dev") {
			for (var i=0; i<custData.length; i++) {
				if (custData[i].DatabaseID.indexOf("DEV") > -1) {
				break; }
				else if (i == custData.length-1) {
					for (var j=0; j<custDataDev.length; j++) {
						custData.push(custDataDev[j]);
					}
				break; }
			}
		}
		for (i=0; i<custData.length; i++) {
			if (custData[i].DataSource == sDataSource) {
				vm.selConf = custData[i];
			break; }
			else if (i == custData.length-1) {
				vm.selConf = custData[0];	
			}		
		}
	}
	
/* Broadcasts: */
	
	
/* Calls from View: */
  
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.selConf.DataSource != "") {
				setCustService.fromDataSource(vm.selConf.DataSource);
				dataService.setDataSource();
				
				if (vm.sUsername.trim() != "" && vm.sPassword.trim() != "") {
					logInUser();
				} else {
					modalService.okAlert("Missing Entry", 
						"Please enter your Username and Password to Log " +
						"In to your account.");
				}
			} else {
				modalService.okAlert("Missing Entry", 
					"Please make a selection from the " +
					"Conference drop-list before logging in.");	
			}	
		}  
	};
	
	vm.forgotPassword_clickHandler = function() {
		if (vm.selConf.DataSource == "") {
			modalService.okAlert("Forgot Password", 
				"Please select your conference from the drop-list, and enter your Username, " +
				"then click the Forgot Password button again.");
		} else if (vm.sUsername == "") {
			modalService.okAlert("Missing Entry", 
				"Please enter your Username, then click the \"Forgot Password\" " +
				"button again.<br>Your password will be emailed to the Email address listed " +
				"on your account.<br><br>" +
				"If you do not receive your password within 10-15 minutes, please contact your " +
				"MissionConnect Administrator to verify that your account email address is correct.");
		} else {
			dataService.sendForgottenPassword(vm.sUsername)
			.then(function(data) { 
				switch (data) {
					case "No User Account":
						modalService.okAlert("Account Not Found", 
							"There is no user account with that Username.<br><br>" +
							"Please be sure you entered it correctly. The Username is " +
							"Case-Sensitive. Otherwise, contact your MissionConnect " +
							"Administrator to verify the Username you are using is correct.");
					break;
					case "Completed":
						modalService.okAlert("Password Sent", 
							"Your password has been sent.\n\n" +
							"Check your Email Inbox for the email with Subject:<br>" +
							"\"Your MissionConnect Login Information\".<br><br>" +
							"If the email does not arrive within 10-15 minutes, be sure " +
							"to also check your spam and junk folders.");
					break;				
				}
			});
		}
	};

//Close MENU:
	vm.onFocus = function() {
		$rootScope.$broadcast('closeMenu');
	};


/* When selected Customer changes, headerService is called to "set"
	new Customer icon & name, which in turn calls to update the 
	NavBarCtrl to reflect the change. */	
	vm.selectConference = function() {
		if (vm.selConf.DataSource != "") {
			setCustService.fromDataSource(vm.selConf.DataSource);
			dataService.setDataSource();
		} else {
			headerService.setCustomer("MissionConnect");
		}
	};
	
	vm.validateUserLogin = function() {
		if (vm.selConf.DataSource != "") {
			if (vm.sUsername.trim() != "" && vm.sPassword.trim() != "") {
				logInUser();
			} else {
				modalService.okAlert("Missing Entry", 
					"Please enter your Username and Password to Log " +
					"In to your account.");
			}
		} else {
			modalService.okAlert("Missing Entry", 
				"Please make a selection from the " +
				"Conference droplist before logging in.");	
		}	
	};
		
}
angular
    .module('mcweb')
    .controller('HelpDeskController', HelpDeskController);

HelpDeskController.$inject = ['helpDeskService','$state','loginService','dataService',
	'validatorService','modalService'];	

function HelpDeskController(helpDeskService, $state, loginService, dataService,
	validatorService, modalService) {
	var vm = this;	//vmHD
	
	vm.bReadyToSubmit;
	vm.iIssueID = 0;
	vm.sUserEmail = "";
	vm.sProblem = "";
	vm.sUserFullName = "";
	
	if (loginService.user.USERID > 0) {
		vm.sUserEmail = loginService.user.USEREMAIL;
		vm.sUserFullName = loginService.user.USERFULLNAME;
	}
	
	helpDeskService.helpHdInitiateIssue()
	.then(function(data) {
		if (data[0].ISSUEID > 0) {
			vm.iIssueID = data[0].ISSUEID;
		} else {
			var sError = "There was an Error retrieving the Help Desk " +
				"IssueID for UserID: " + loginService.user.USERID + ", " +
				loginService.user.USERFULLNAME + "<br><br>Reporting issue: " +
				vm.sProblem;
			dataService.emailSendError(sError);
		}		
	});
		
		
/* Externally Called Functions: */

	vm.confirmReadyToSubmit = function() {
		if (vm.sUserFullName != "" && vm.sUserEmail != "" &&
			vm.sProblem != "") {
			if (validatorService.emailIsValid(vm.sUserEmail) == true) {
				vm.bReadyToSubmit = "true"; }
			else {
				vm.bReadyToSubmit = "false";
				modalService.okAlert("Invalid Entry",
					"The email entered is not a valid email address.<br><br>" +
					"Please enter a valid email address, then click Submit.");		
			}	
		} else { vm.bReadyToSubmit = "false"; }
	};
	
	vm.submitHD = function() {
		if (vm.bReadyToSubmit == "true") {
			if (vm.iIssueID > 0) {
				helpDeskService.helpHdSaveIssue(vm.iIssueID, vm.sUserFullName,
					vm.sUserEmail, vm.sProblem);
			}
		} else if (vm.sUserFullName == "") {
			modalService.okAlert("Missing Data", 
				"Please enter your Name before Submitting " +
				"the Help Desk issue.");
		} else if (vm.sUserEmail == "") {
			modalService.okAlert("Missing Data", 
				"Please enter your Email Address before " +
				"Submitting the Help Desk issue.");

		} else if (vm.sProblem == "") {
			modalService.okAlert("Missing Data", 
				"Please describe the issue you are experiencing " +
				"before Submitting the Help Desk issue.");		
		}
	};	
	
}
angular		
	.module('mcweb')
	.controller('ConfSelController', ConfSelController);

ConfSelController.$inject = ['dataService', '$window', '$state', 'headerService', 'webSessionStorage','$rootScope'];
	
function ConfSelController(dataService, $window, $state, headerService, webSessionStorage,
	$rootScope) {
	var vm = this;
	
	vm.Confs = [];
	vm.selConf = {};
	
	dataService.helpLoadCustomers()
	.then(function(data) {
		if (data.length > 0) {
			for (var i=0; i<data.length; i++) {
/*
				if (data[i].DATABASEID.indexOf("DEV") > -1) {
					data.splice(i, 1);
					i--; 
				} else
*/
				if (data[i].DATABASEID == 'Demo' ||
					data[i].DATABASEID == 'KSE' ||
					data[i].DATABASEID == 'KSW' ||
					data[i].DATABASEID == 'MC' ||
					data[i].DATABASEID == 'NIL' ||
					data[i].DATABASEID == 'RIO' ||
					data[i].DATABASEID == 'VID') {
					data.splice(i, 1);
					i--; 
				}
			}
			vm.Confs = data;
			vm.Confs.unshift({
				DATABASEID: "",
				CUSTOMERNAME: '<No Selection>'
			});
			vm.selConf = vm.Confs[0];					
		}
	});

	
/* Calls from View: */
	vm.selectConference = function() {
		$rootScope.sDatabaseID = vm.selConf.DATABASEID;
		headerService.setCustomer(vm.selConf.DATABASEID, vm.selConf.CUSTOMERNAME)
		webSessionStorage.setStoredData('sDataSource', vm.selConf.DATABASENAME);
		webSessionStorage.setStoredData('sDatabaseID', vm.selConf.DATABASEID);
		dataService.setDataSource();
	};
	
	vm.cmdContinue_clickHandler = function() {
		if (vm.selConf.DATABASEID == "") {
			$window.alert("You must first make a selection from the \n" +
							"Conference droplist before proceeding."); 
		} else {
			headerService.setAppBarColor('Center');
			$rootScope.sCurForm = 'contactInfo';
			$state.go('contactInfo');
		}	
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			headerService.setAppBarColor('Center');
			$rootScope.sCurForm = 'contactInfo';
			$state.go('contactInfo');
		}
	};
	
}
angular
    .module('mcweb')
    .controller('CIPeoResultsController', CIPeoResultsController);

CIPeoResultsController.$inject = ['$stateParams','dataService','$state','$rootScope',
	'$scope','modalService','loginService'];

function CIPeoResultsController($stateParams, dataService, $state, $rootScope,
	$scope, modalService, loginService) {
    var vm = this;
	
	vm.arrUserChurch = loginService.user.UserChurchFNs;
	vm.bHidePrimary = false;		//indicates to hide PrimaryChurch field from Display -- not in return
	vm.iPastorID = loginService.user.USERENTITYID;
	vm.peopleResults = [];
	vm.selEntityID = 0;
	vm.sFirstName = $stateParams.sFirstName;
	vm.sLastName = $stateParams.sLastName;
	vm.sNoResults_msg = "No Results Found for the entered criteria.";						 
	
	$rootScope.sCurForm = 'CI: People Results';
	
	if ($stateParams.sEmail != "") {
		vm.bHidePrimary = true;
		dataService.peoGetByEmail($stateParams.sEmail)
		.then(function(data) {
			if (data.length > 0) {
				if ($rootScope.selEntityID > 0) {
					for (var i=0; i<data.length; i++) {
						if (data[i].ENTITYID === $rootScope.selEntityID) {
							vm.selEntityID = data[i].ENTITYID;
						break; }
						else if (i == data.length-1) {
							$rootScope.selEntityID = 0;
						}
					}
				}
				vm.peopleResults = data;
			} else {
				modalService.okAlert("No Results", vm.sNoResults_msg);
			}
		});
	} else {
		if (vm.sLastName == "" && vm.sFirstName == "") {
			modalService.okAlert("Missing Entry", 
				"You must enter a portion of the First or Last Name " +
				"to perform a search.");
		} else {
			if (vm.sLastName == "") { vm.sLastName = "%"; }
			if (vm.sFirstName == "") { vm.sFirstname = "%"; }
			vm.bHidePrimary = false;
			dataService.peoGetForChurch(vm.sLastName, vm.sFirstName) 
			.then(function(data) { 
				if (data.length > 0) {
					if ($rootScope.selEntityID > 0) {
						for (var i=0; i<data.length; i++) {
							if (data[i].ENTITYID == $rootScope.selEntityID) {
								vm.selEntityID = data[i].ENTITYID;
							break; }
							else if (i == data.length-1) {
								$rootScope.selEntityID = 0;
							}
						}
					}
					vm.peopleResults = data;
				} else {
					modalService.okAlert("No Results", vm.sNoResults_msg);
				}
			});
		}	
	}
	

/* Calls from View: */
	
	vm.loadContactInfo = function(person) {
		$rootScope.selEntityID = person.ENTITYID;
		var sPersonName = person.PERSONNAME;
		$state.go('peoDisplay', {
			sPersonFullName: sPersonName
		});
	};
	
}
angular
	.module('mcweb')
	.controller('CIPeoFindController', CIPeoFindController);

CIPeoFindController.$inject = ['dataService','modalService','$state','$rootScope'];

function CIPeoFindController(dataService, modalService, $state, $rootScope) {
	var vm = this;
	
	vm.search = "";
	vm.sEmail = "";
	vm.sFirstName = "";
	vm.sLastName = "";
	vm.sMissingEmail_msg = "A valid Email Address is required \n" +
							"before a search can be performed.";
	vm.sMissingNames_msg = "An entry into the Last Name or First \n" +
							"Name field is required before a search\n" +
							"can be performed.";
	
	$rootScope.sCurForm = "CI: Find People";
	$rootScope.$broadcast('closeMenu');
	
	if (vm.search == "") { vm.search = "name"; }
	
	function getPeoResults() {
		switch (vm.search) {
			case "name":
				vm.sEmail = "";
				if (vm.sLastName != "%") {
					vm.sLastName = vm.sLastName.trim();
				}
				if ( vm.sFirstName != "%") {
					vm.sFirstName = vm.sFirstName.trim();
				}
				$state.go('peoResults', {
					sLastName: vm.sLastName,
					sFirstName: vm.sFirstName,
					sEmail:""
				}, {reload:false}); //false: to go back to same loaded list, incase selected wrong person
			break;
			case "email":
				if (vm.sEmail != "") {
					$state.go('peoResults', {
						sLastName:"", sFirstName:"",
						sEmail: vm.sEmail.trim()
					}, {reload:false}); //false: to go back to same loaded list, incase selected wrong person
				} else {
					modalService.okAlert("Missing", vm.sMissingEmail_msg);
				}
			break;		
		}
	}
	
	
/* Calls from View: */
	
	vm.searchForAPerson = function() {
		getPeoResults();
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			getPeoResults();
		}  
	};
	
	vm.clear = function() {
		vm.sLastName = "";
		vm.sFirstName = "";
		vm.sEmail = "";
		$rootScope.selEntityID = 0;
		$state.go('peoFind', {reload:true});
	};

}
angular
	.module('mcweb')
	.controller('CIPeoDisplayController', CIPeoDisplayController);

CIPeoDisplayController.$inject = ['$rootScope','dataService','$scope','$stateParams'];

function CIPeoDisplayController($rootScope, dataService, $scope, $stateParams) {
	var vm = this;
	
	vm.Addresses = [];
	vm.Emails = [];
	vm.Phones = [];
	vm.sPersonFullName = $stateParams.sPersonFullName;
	
	$rootScope.sCurForm = "CI: Person Display";
	
	dataService.addrGetAll($rootScope.selEntityID)
	.then(function(data) {
		if (data.length > 0) {
			//remove Past:
			for (var i=0; i<data.length; i++) {
				if (data[i].STOPDATE != "") {
					//confirm stopdate in past:	 				
					var dStop = new Date(data[i].STOPDATE);					
					var dNow = new Date();
					if (dStop < dNow) {
						data.splice(i,1);
						i--;
					}					
				}	
			}

			if (data.length > 0) {
				vm.Addresses = data;
			} else {
				vm.Addresses.push = {ADDR1:"No Address Available",
					ADDR2:"",CITY:"",STATE:"",ZIP:""};	
			}
		} else {
			vm.Addresses.push = {ADDR1:"No Address Available",
				ADDR2:"",CITY:"",STATE:"",ZIP:""};
		}
		
	});

	dataService.phGetAll($rootScope.selEntityID)
	.then(function(data) {
		if (data.length > 0) {
			//remove Past:
			for (var i=0; i<data.length; i++) {
				if (data[i].STOPDATE != "") {
					//confirm stopdate in past:	 				
					var dStop = new Date(data[i].STOPDATE);					
					var dNow = new Date();
					if (dStop < dNow) {
						data.splice(i,1);
						i--;
					}					
				}
			}
			//remove "Private" Phones:
			for (i=0; i<data.length; i++) {
				if (data[i].PRIVACY != "Public") {
					data.splice(i,1);
					i--;
				}					
			} 	
			if (data.length > 0) {
				vm.Phones = data;
			} else {
				vm.Phones.push = {PHONENUMBER:"No Phones Available"};	
			}
		} else {
			vm.Phones.push = {PHONENUMBER:"No Phones Available"};
		}	
	});
	
	dataService.emGetAll($rootScope.selEntityID)
	.then(function(data) {
		if (data.length > 0) {
			//remove Past:
			for (var i=0; i<data.length; i++) {
				if (data[i].STOPDATE != "") {
					//confirm stopdate in past:	 				
					var dStop = new Date(data[i].STOPDATE);					
					var dNow = new Date();
					if (dStop < dNow) {
						data.splice(i,1);
						i--;
					}					
				}
			}
			//remove "Private" Emails:
			for (i=0; i<data.length; i++) {
				if (data[i].PRIVACY != "Public") {
					data.splice(i,1);
					i--;
				}					
			} 	
			if (data.length > 0) {
				vm.Emails = data;
			} else {
				vm.Emails.push = {EMAIL:"No Emails Available"};	
			}
		} else {
			vm.Emails.push = {EMAIL:"No Emails Available"};
		}
	});

}

angular
    .module('mcweb')
    .controller('CIChResultsController', CIChResultsController);

CIChResultsController.$inject = ['$stateParams', 'dataService', '$state', '$rootScope',
	'$scope','modalService'];

function CIChResultsController($stateParams, dataService, $state, $rootScope,
	$scope, modalService) {
    var vm = this;

	vm.churchResults = [];
	vm.selChurchID = 0;
	vm.sNoResults_msg = "No Results Found for the entered criteria.";						 

	$rootScope.sCurForm = "CI: Church Results";
	
	if ($stateParams.sChurchName != "") {
		dataService.chLoadAll($stateParams.sChurchName)		
		.then(function(data) {
			if (data.length > 0) {
				if ($rootScope.selChurchID > 0) {
					for (var i=0; i<data.length; i++) {
						if (data[i].ENTITYID === $rootScope.selChurchID) {
							vm.selChurchID = data[i].ENTITYID;
						break; }
						else if (i == data.length-1) {
							$rootScope.selChurchID = 0;
						}
					}
				}
				vm.churchResults = data;
			} else {
				modalService.okAlert("No Results", vm.sNoResults_msg);
			}
		});
	}

	
/* Calls from View: */
	
	vm.loadContactInfo = function(church) {
		var sChurchName = church.ENTITYNAME;		
		$rootScope.selChurchID = church.ENTITYID;
		$state.go('chDisplay', {
			sChurchName: sChurchName
		});
	};

}

angular
    .module('mcweb')
    .controller('CIChFindController', CIChFindController);

CIChFindController.$inject = ['dataService', 'modalService', '$state', '$rootScope'];

function CIChFindController(dataService, modalService, $state, $rootScope) {
	var vm = this;
	
	vm.sChurchName = "";
	
	$rootScope.sCurForm = "CI: Find Church";
	$rootScope.$broadcast('closeMenu');
		
	function getChResults() {
		if (vm.sChurchName != "") {
			$rootScope.sCurForm = 'chResults';
			$state.go('chResults', {
				sChurchName: vm.sChurchName.trim()
			}, {reload:false});
		} else {
			modalService.okAlert("Missing Entry", 
				"An entry into the Church Name field is " +
				"required before a search can be performed.");
		}
	}
	
	
/* Calls from View: */		 

	vm.searchForAChurch = function() {
		getChResults();
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			getChResults();
		}  
	};
	
	vm.clearResults = function() {
		vm.sChurchName = "";
		$rootScope.selChurchID = 0;
		$state.go('chFind', {reload:true});
	};

}

angular
	.module('mcweb')
	.controller('CIChDisplayController', CIChDisplayController);

CIChDisplayController.$inject = ['$rootScope','dataService','$scope','$stateParams'];

function CIChDisplayController($rootScope, dataService, $scope, $stateParams) {
	var vm = this;
	
	vm.Addresses = [];
	vm.Phones = [];
	vm.Emails = [];
	vm.sChurchName = $stateParams.sChurchName;

	$rootScope.sCurForm = "CI: Church Display";

	dataService.addrGetAll($rootScope.selChurchID)
	.then(function(data) {
		if (data.length > 0) {
			//remove Past:
			for (var i=0; i<data.length; i++) {
				if (data[i].STOPDATE != "") {
					//confirm stopdate in past:	 				
					var dStop = new Date(data[i].STOPDATE);					
					var dNow = new Date();
					if (dStop < dNow) {
						data.splice(i,1);
						i--;
					}					
				}	
			}

			if (data.length > 0) {
				vm.Addresses = data;
			} else {
				vm.Addresses.push = {ADDR1:"No Address Available",
					ADDR2:"",CITY:"",STATE:"",ZIP:""};	
			}
		} else {
			vm.Addresses.push = {ADDR1:"No Address Available",
				ADDR2:"",CITY:"",STATE:"",ZIP:""};
		}
		
	});

	dataService.phGetAll($rootScope.selChurchID)
	.then(function(data) {
		if (data.length > 0) {
			//remove Past:
			for (var i=0; i<data.length; i++) {
				if (data[i].STOPDATE != "") {
					//confirm stopdate in past:	 				
					var dStop = new Date(data[i].STOPDATE);					
					var dNow = new Date();
					if (dStop < dNow) {
						data.splice(i,1);
						i--;
					}					
				}
			}
			//remove "Private" Phones:
			for (i=0; i<data.length; i++) {
				if (data[i].PRIVACY != "Public") {
					data.splice(i,1);
					i--;
				}					
			} 	
			if (data.length > 0) {
				vm.Phones = data;
			} else {
				vm.Phones.push = {PHONENUMBER:"No Phones Available"};	
			}
		} else {
			vm.Phones.push = {PHONENUMBER:"No Phones Available"};
		}	
	});
	
	dataService.emGetAll($rootScope.selChurchID)
	.then(function(data) {
		if (data.length > 0) {
			//remove Past:
			for (var i=0; i<data.length; i++) {
				if (data[i].STOPDATE != "") {
					//confirm stopdate in past:	 				
					var dStop = new Date(data[i].STOPDATE);					
					var dNow = new Date();
					if (dStop < dNow) {
						data.splice(i,1);
						i--;
					}					
				}
			}
			//remove "Private" Emails:
			for (i=0; i<data.length; i++) {
				if (data[i].PRIVACY != "Public") {
					data.splice(i,1);
					i--;
				}					
			} 	
			if (data.length > 0) {
				vm.Emails = data;
			} else {
				vm.Emails.push = {EMAIL:"No Emails Available"};	
			}
		} else {
			vm.Emails.push = {EMAIL:"No Emails Available"};
		}
	});

}	

angular
    .module('mcweb')
    .controller('ChgPasswordController', ChgPasswordController);

ChgPasswordController.$inject = ['$rootScope','$state', 'passwordStrength',
	'validatorService', 'confirmPWChg', 'dataService','loginService','modalService','appValidationService'];

function ChgPasswordController($rootScope, $state, passwordStrength,
	validatorService, confirmPWChg, dataService, loginService, modalService, appValidationService) {
	var vm = this;	//vmCP
    
    vm.bReadyToSave = "false";
    vm.bReadyToSavePW = false;
    vm.bReadyToSaveEmail = false;
    vm.sPasswordStrength = "Too Short";
    vm.sPWClass = "tooShort";
    vm.sUserEmail = loginService.user.USEREMAIL;
    
    vm.data = { oldPW:"",
		newPW:"", confirmPW:"",
		email:"", confirmEmail:""	
	};
	
	$rootScope.sCurForm = "Change Password/Email";
    
	function validateEmail() {
		var emValidate = confirmPWChg.confirmEmail(vm.data.email, vm.data.confirmEmail);
		switch (emValidate) {
			case "true": 
				if (validatorService.emailIsValid(vm.data.email) == true) {
					vm.bReadyToSaveEmail = true; }
				else {
					vm.bReadyToSaveEmail = false;
					vm.data.confirmEmail = "";
					modalService.okAlert("Invalid Email Address", 
						"The email entered is not a valid email address.<br><br>" +
						"Please enter a valid email address.");
				}
			break;
			case "false": 
				//returned when email or confirmEmail is ""
				vm.bReadyToSaveEmail = false;
			break;
			default:
				modalService.okAlert("", emValidate);
			break;
		}
	}
	
	function validatePW() {
		if (vm.data.oldPW != "") {
			var validatePassword = confirmPWChg.confirmPassword(vm.data.newPW, vm.data.confirmPW);
			switch (validatePassword) {
				case "true": 
					if (vm.sPasswordStrength == "Strong" ||
						vm.sPasswordStrength == "Very Strong") {
							vm.bReadyToSavePW = true; 
					} else {
						vm.bReadyToSavePW = false;
						vm.data.confirmPW = "";
						modalService.okAlert("Password Strength", 
							"The password needs to meet the \"Strong\" " +
							"or \"Very Strong\" validation before it can be saved.");
					}
				break;		
				case "false":
					vm.bReadyToSavePW = false;
				break;
				default:
					vm.bReadyToSavePW = false;
					vm.data.confirmPW = "";
					modalService.okAlert("Password Validation", validatePassword);
				break;
			}		
		}
	}
    
    //Already logged in before updating Email or Password:
    function saveNewEmail() {
		var sSaveString = "MCWebApps || chgPW || " + loginService.user.USERID + 
			" || U || UserID==" + loginService.user.USERID + 
			" || UserEmail==" + vm.data.email + " ^^ ";
			
		dataService.usersSave(sSaveString)
		.then(function(data) {
            if (data[0].RESULTCODE == "Success") {
				var sSaveSuccessMsg = "Your email has been updated successfully!<br>";
				if (vm.bReadyToSavePW != true) {
					modalService.okAlert("Save Successful", sSaveSuccessMsg);

					if (!$rootScope.bPasswordExpired) {
						if (appValidationService.validateAccess() == "Valid") {	
							$rootScope.sCurForm = 'Contact Information';
							$state.go('contactInfo');
						} else { 
							$rootScope.sCurForm = 'Login';
							$state.go('login'); 
						}
					} else { 
						loginService.user.USEREMAIL = vm.sNewEmail;
						$state.reload();
					}
				} else {
					//also saving new Password:
					saveNewPassword(sSaveSuccessMsg);	
				}
			} else {
				modalService.okAlert("Save Failed", data[0].RESULTCODE);
			}
		});
    }
    
	function saveNewPassword(msg) {
		var sSaveString = "MCWebApps || chgPW || " + loginService.user.USERID +
			" || U || UserID==" + loginService.user.USERID + " || UserName==" +
			loginService.user.USERNAME + " || OldPassword==" + vm.data.oldPW +
			" || NewPassword==" + vm.data.newPW + " || PWStrength==" + 
			vm.sPasswordStrength + " ^^ ";

		dataService.usersChangePassword(sSaveString)
		.then(function(data) {
			if (data[0].RESULTCODE == "Success") {
				$rootScope.bPasswordExpired = false;
				modalService.okAlert("Save Successful", 
					"Your password has been updated successfully!");

				//No need to store updated Password. 
				if (appValidationService.validateAccess() == "Valid") {
					$rootScope.sCurForm = 'Contact Information';
					$state.go('contactInfo');
				} else { 
					$rootScope.sCurForm = 'Login';
					$state.go('login'); 
				}	
			} else {
				$state.reload();
				modalService.okAlert("Save Failed", msg + data[0].RESULTREASON);
			}
		});	
    }
    
/* Externally Called Functions: */

    vm.cancelChanges = function() {
		if ($rootScope.bPasswordExpired) {
			$state.reload();
			modalService.okAlert("Expired",
				"Your password is expired, and must be updated before you may " +
				"use the application.");
		} else {
			//Return to Landing page for app:
			$rootScope.sCurForm = 'Contact Information';
			$state.go('contactInfo');
		}
	};
    
    vm.checkPWStrength = function() {
		var pwReturn = passwordStrength.getPWStrength(vm.data.newPW);
		vm.sPasswordStrength = pwReturn.strength;
		vm.sPWClass = pwReturn.class;
	};  

    vm.confirmReadyToSave = function(item) {
		switch (item) {
			case "email":
				validateEmail();	
			break;
			case "pw":
				validatePW();
			break;
		}
		//May be updating PW, Email or both...		
		if (vm.bReadyToSavePW == true) {
			if ((vm.data.email=="" && vm.data.confirmEmail=="") ||
				vm.bReadyToSaveEmail == true) {
				vm.bReadyToSave = 'true'; 
			} else { vm.bReadyToSave = 'false'; }
		} else if (vm.bReadyToSaveEmail == true &&
			vm.data.newPW == "" && vm.data.confirmPW == "") {
				vm.bReadyToSave = 'true';
		} else { vm.bReadyToSave = 'false'; }
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.bReadyToSave == "true") {
				if (vm.bReadyToSaveEmail == true) {
					saveNewEmail();
				} else if (vm.bReadyToSavePW == true) {
					saveNewPassword("");
				}	
			}	
		}  
	};

    vm.saveChanges = function() {
		if (vm.bReadyToSave == "true") {
			if (vm.bReadyToSaveEmail == true) {
				saveNewEmail();
			} else if (vm.bReadyToSavePW == true) {
				saveNewPassword("");
			}	
		} else if (vm.data.newPW != "" && vm.data.confirmPW != "") {
			validatePW();
		} else if (vm.data.email != "" && vm.data.confirmEmail != "") {
			validateEmail();
		} else { 
			modalService.okAlert("Oops!", 
				"We did not find any data changes to Save.");  
		}
    };
    
}
(function() {
	'use strict';

	angular
		.module('mcweb')
		.config(routerConfig);

	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('index', {
			url: '/index.html',
			templateUrl: 'app/views/login.html',
			controller: 'LoginController',
			controllerAs: 'vmLI'
		})
		.state('login', {
			url: '/login',
			templateUrl: 'app/views/login.html',
			controller: 'LoginController',
			controllerAs: 'vmLI'
		})
		.state('about', {
			url: '/about',
			templateUrl: 'app/views/about.html'
		})
		.state('chgPW', {
			url: '/chgPW',
			templateUrl: 'app/views/chgPW.html',
			controller: 'ChgPasswordController',
			controllerAs: 'vmCP'
		})
		.state('helpDesk', {
			url: '/helpDesk',
			templateUrl: 'app/views/helpDesk.html',
			controller: 'HelpDeskController',
			controllerAs: 'vmHD'
		})
		.state('selApp', {
			url: '/selApp',
			templateUrl: 'app/views/appSelect.html'
		})
		.state('contactInfo', {
			url: '/contactInfo',
			templateUrl: 'app/views/contactInfo.html'
		})
			.state('peoFind', {
				parent: 'contactInfo',
				templateUrl: 'app/partials/ciPeoFind.html',
				controller: 'CIPeoFindController',
				controllerAs: 'vmCIP'
			})
				.state('peoResults', {
					parent: 'peoFind',
					templateUrl: 'app/partials/ciPeoResults.html',
					controller: 'CIPeoResultsController',
					controllerAs: 'vmCIPR',
					params: {
						sLastName: "", sFirstName: "",
						sEmail:""
					}	
				})
				.state('peoDisplay', {
					parent: 'peoFind',
					templateUrl: 'app/partials/ciPeoDisplay.html',
					controller: 'CIPeoDisplayController',
					controllerAs: 'vmCIPD',
					params: {
						sPersonFullName: ""
					}		
				})
			
			.state('chFind', {
				parent: 'contactInfo',
				templateUrl: 'app/partials/ciChFind.html',
				controller: 'CIChFindController',
				controllerAs: 'vmCIC'
			})
				.state('chResults', {
					parent: 'chFind',
					templateUrl: 'app/partials/ciChResults.html',
					controller: 'CIChResultsController',
					controllerAs: 'vmCICR',
					params: { sChurchName: "" }		
				})
				.state('chDisplay', {
					parent: 'chFind',
					templateUrl: 'app/partials/ciChDisplay.html',
					controller: 'CIChDisplayController',
					controllerAs: 'vmCICD',
					params: {
						sChurchName: ""
					}		
				});
				
		$urlRouterProvider.otherwise('/index.html');
	}

})();

(function() {
	'use strict';

	angular
		.module('mcweb')
//TEST*/.constant('version', '1.000.033')
/*LIVE*/.constant('version', '1.000.043')
		.constant('authServiceCFC', 'https://umcdata.net/Falcon/libCFCs/AuthService.cfc')
		.constant('mcWebCFC', 'https://umcdata.net/Falcon/libCFCs/MC_Web.cfc')
		.constant('proJsCFC', 'https://umcdata.net/Falcon/libCFCs/Protect_JS.cfc')
		.constant('helpDeskCFC', 'https://umcdata.net/Falcon/libCFCs/HelpDesk.cfc')
//		.constant('testCFC', 'https://umcdata.net/Falcon/libCFCs/Testing.cfc')
		.constant('lclURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/LCLeaders/#/index.html')
		.constant('mcWebAppsURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/#/index.html')
		.constant('minFinURL', 'https://umcdata.net/MissionConnect/Public/RcvWeb/#/login')
		.constant('protectURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Protect/#/index.html')
		.constant('statsURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Statistics/#/index.html')
		.constant('vancoPay', 'https://umcdata.net/MissionConnect/Public/VancoPay/#/index.html')
		.constant('custData', [
			{
				"DataSource":"",
				"DatabaseID":"GSS",
				"CustomerName":"<No Selection>"
			},
			{
				"DataSource":"FalconArk",
				"DatabaseID":"AR",
				"CustomerName":"Arkansas Conference"
			},
			{
				"DataSource":"FalconDemo",
				"DatabaseID":"Demo",
				"CustomerName":"Demo Database"
			},
			//EOH
			{
				"DataSource":"FalconKy",
				"DatabaseID":"KY",
				"CustomerName":"Kentucky Annual Conference"
			},
			{
				"DataSource":"FalconLa",
				"DatabaseID":"LA",
				"CustomerName":"Louisiana Conference"
			},
			{
				"DataSource":"FalconMc",
				"DatabaseID":"MC",
				"CustomerName":"McCurdy Ministries",
				"ProRef": "Protect References"
			},
			{
				"DataSource":"FalconMem",
				"DatabaseID":"MEM",
				"CustomerName":"Memphis Conference"
			},
			{
				"DataSource":"FalconMo",
				"DatabaseID":"MO",
				"CustomerName":"Missouri Conference",
				"ProRef":"Safe Sanctuary References"
			},
			//MN,FalconMinn
			{
				"DataSource":"FalconNm",
				"DatabaseID":"NM",
				"CustomerName":"New Mexico Conference"
			},
			{
				"DataSource":"FalconNwtx",
				"DatabaseID":"NWTX",
				"CustomerName":"Northwest Texas Conference",
				"ProRef":"Volunteer References"
			},
			//PR
			{
				"DataSource":"FalconRm",
				"DatabaseID":"RM",
				"CustomerName":"Rocky Mountain Conference"
			},
			{
				"DataSource":"FalconSwtx",
				"DatabaseID":"SWTX",
				"CustomerName":"Rio Texas Conference"
			},
			{
				"DataSource":"FalconSg",
				"DatabaseID":"SGA",
				"CustomerName":"South Georgia Conference"
			},
			{
				"DataSource":"FalconTenn",
				"DatabaseID":"TN",
				"CustomerName":"Tennessee Conference"
			},
			{
				"DataSource":"FalconUny",
				"DatabaseID":"UNY",
				"CustomerName":"Upper New York Conference"
			},
			//VID,FalconVideos
			//WI,FalconWi
			//WOH,FalconWoh
			{
				"DataSource":"FalconYw",
				"DatabaseID":"YW",
				"CustomerName":"Mountain Sky Conference"
			}
		])
		.constant('custDataDev',[
			{
				"DataSource":"FalconArkDev",
				"DatabaseID":"AR-DEV",
				"CustomerName":"Arkansas Conference  (AR-DEV)"
			},
			{
				"DataSource":"FalconKyDev",
				"DatabaseID":"KY-DEV",
				"CustomerName":"Kentucky Annual Conference  (KY-DEV)"
			},
			{
				"DataSource":"FalconLaDev",
				"DatabaseID":"LA-DEV",
				"CustomerName":"Louisiana Conference (LA-DEV)"
			},
			{
				"DataSource":"FalconMcDev",
				"DatabaseID":"MC-DEV",
				"CustomerName":"McCurdy Ministries (MC-DEV)",
				"ProRef": "Protect References"
			},
			{
				"DataSource":"FalconMemDev",
				"DatabaseID":"MEM-DEV",
				"CustomerName":"Memphis Conference  (MEM-DEV)"
			},
			{	
				"DataSource":"FalconMoDev",
				"DatabaseID":"MO-DEV",
				"CustomerName":"Missouri Conference (MO-DEV)",
				"ProRef":"Safe Sanctuary References"
			},
			{
				"DataSource":"FalconNmDev",
				"DatabaseID":"NM-DEV",
				"CustomerName":"New Mexico Conference (NM-DEV)"
			},
			{
				"DataSource":"FalconNwtxDev",
				"DatabaseID":"NWTX-DEV",
				"CustomerName":"NWTX Conference (NWTX-DEV)",
				"ProRef":"Volunteer References"
			},
			{
				"DataSource":"FalconSwtxDev",
				"DatabaseID":"SWTX-DEV",
				"CustomerName":"Rio Texas Conference (SWTX-DEV)"
			},
			{
				"DataSource":"FalconSgDev",
				"DatabaseID":"SGA-DEV",
				"CustomerName":"South Georgia Conference  (SGA-DEV)"
			},
			{
				"DataSource":"FalconTennDev",
				"DatabaseID":"TN-DEV",
				"CustomerName":"Tennessee Conference  (TN-DEV)"
			},
			{
				"DataSource":"FalconUnyDev",
				"DatabaseID":"UNY-DEV",
				"CustomerName":"Upper New York Conference  (UNY-DEV)"
			},
			{
				"DataSource":"FalconVideos",
				"DatabaseID":"VID",
				"CustomerName":"Demo Conference",
				"ProRef":"Safe Sanctuary References"
			}
		]);

})();

angular.module("mcweb").run(["$templateCache", function($templateCache) {$templateCache.put("app/modals/modAlert.html","<div><!-- ng-controller=\"ModalController as vmMod\" --><div class=\"modal-header MCGrn75\"><h3 class=modal-title>{{ vmMod.sTitle }}</h3></div><div class=modal-body><!-- HTML Message: --><p ng-bind-html=vmMod.sAlertMsg></p></div><div class=modal-footer><!-- OK Alert Example: --><div class=divR ng-show=\"vmMod.modType==\'OK\'\"><button class=\"btn btn-primary\" type=button ng-click=vmMod.cancel()>OK</button></div></div></div>");
$templateCache.put("app/partials/ciChDisplay.html","<!-- CIChDisplayController as vmCICD --><div class=ciDisplay><div><div class=hr250></div><h4 class=txtCtr>{{ vmCICD.sChurchName}}</h4><h5 class=h5>Address</h5><div ng-class={primary:addr.PRIMARYADDR} ng-model=addr.PRIMARYADDR ng-repeat=\"addr in vmCICD.Addresses | orderBy:\'-PRIMARYADDR\' track by $index\"><h5>{{ addr.ADDRTYPE }}:</h5><h5 class=indent>{{ addr.ADDR1 }}</h5><h5 class=indent>{{ addr.ADDR2 }}</h5><h5 class=indent>{{ addr.CITY }}, {{ addr.STATE }}&nbsp;&nbsp; {{ addr.ZIP | fZipcode }}</h5></div></div><div><h5 class=h5>Phone</h5><div ng-class={primary:ph.PRIMARYPHONE} ng-model=ph.PRIMARYPHONE ng-repeat=\"ph in vmCICD.Phones\"><h5 class=indent>{{ ph.PHONETYPE }}:&nbsp;&nbsp; {{ ph.PHONENUMBER | fPhone }}<h5><h5 class=indent2 ng-hide=\"ph.EXTENSION == \'\'\">Extension:&nbsp;{{ ph.EXTENSION }}</h5></h5></h5></div></div><div><h5 class=h5>EMail</h5><div ng-class={primary:em.PRIMARYEMAIL} ng-model=em.PRIMARYEMAIL ng-repeat=\"em in vmCICD.Emails\"><h5>{{ em.EMAILTYPE }}:</h5><h5 class=indent>{{ em.EMAIL }}<h5></h5></h5></div></div></div>");
$templateCache.put("app/partials/ciChFind.html","<!-- CIChFindController as vmCIC --><div class=\"form-group padR\"><label for=txtChurchName>Church Name</label><input id=txtChurchName type=text class=form-control placeholder=\"Enter portion of Church Name\" ng-keypress=vmCIC.enterKeyHandler($event) ng-model=vmCIC.sChurchName></div><div class=divCtr><div class=divLCtr><button class=\"btnCtr MCGold\" ng-click=vmCIC.searchForAChurch()>Search</button></div><div class=divRCtr><button class=btnCtr ng-click=vmCIC.clearResults()>Clear</button></div></div><!-- chResults & chDisplay go here:	 --><ui-view></ui-view>");
$templateCache.put("app/partials/ciChResults.html","<!-- CIChResultsController as vmCICR --><div class=padL><h5>Click on a name to load the Contact<br>Information, or return to Search.</h5><table class=\"table table-hover\"><thead><th>Church Search Results:</th></thead><tbody><tr ng-repeat=\"church in vmCICR.churchResults | orderBy:ENTITYNAME track by $index\"><td ng-model=church.ENTITYID ng-class=\"{selEntity:church.ENTITYID === vmCICR.selChurchID}\" ng-click=vmCICR.loadContactInfo(church)>{{ church.ENTITYNAME }}</td></tr></tbody></table></div>");
$templateCache.put("app/partials/ciPeoDisplay.html","<!-- CIPDisplayController as vmCIPD --><div class=ciDisplay ng-hide=\"cmCIPD.sPersonFullName==\'\'\"><div><div class=hr250></div><h4 class=txtCtr>{{ vmCIPD.sPersonFullName}}</h4><h5 class=h5>Address</h5><div ng-class={primary:addr.PRIMARYADDR} ng-model=addr.PRIMARYADDR ng-repeat=\"addr in vmCIPD.Addresses | orderBy:\'-PRIMARYADDR\' track by $index\"><h5>{{ addr.ADDRTYPE }}:</h5><h5 class=indent>{{ addr.ADDR1 }}</h5><h5 class=indent>{{ addr.ADDR2 }}</h5><h5 class=indent>{{ addr.CITY }}, {{ addr.STATE }}&nbsp;&nbsp; {{ addr.ZIP | fZipcode }}</h5></div></div><div><h5 class=h5>Phone</h5><div ng-class={primary:ph.PRIMARYPHONE} ng-model=ph.PRIMARYPHONE ng-repeat=\"ph in vmCIPD.Phones\"><h5 class=indent>{{ ph.PHONETYPE }}:&nbsp;&nbsp; {{ ph.PHONENUMBER | fPhone }}<h5><h5 class=indent2 ng-hide=\"ph.EXTENSION == \'\'\">Extension:&nbsp;{{ ph.EXTENSION }}</h5></h5></h5></div></div><div><h5 class=h5>EMail</h5><div ng-class={primary:em.PRIMARYEMAIL} ng-model=em.PRIMARYEMAIL ng-repeat=\"em in vmCIPD.Emails\"><h5>{{ em.EMAILTYPE }}:</h5><h5 class=indent>{{ em.EMAIL }}<h5></h5></h5></div></div></div>");
$templateCache.put("app/partials/ciPeoFind.html","<!-- CIPeoFindController as vmCIP --><div class=divCtr><div class=divLCtr><label for=optName class=radio-inline><input id=optName type=radio ng-model=vmCIP.search value=name ng-click=vmCIP.clear()> Last/First Name</label></div><div class=divRCtr><label for=optEmail class=radio-inline><input id=optEmail type=radio ng-model=vmCIP.search value=email ng-click=vmCIP.clear()> Email Address</label></div></div><form ng-show=\"vmCIP.search==\'name\'\"><div class=form-group><label for=txtLastName>Last Name&nbsp;</label><input id=txtLastName type=text class=form-control-med210 autofocus placeholder=\"Enter portion of Name\" ng-model=vmCIP.sLastName ng-keypress=vmCIP.enterKeyHandler($event)></div><div class=form-group><label for=txtFirstName>First Name&nbsp;</label><input id=txtFirstName type=text class=form-control-med210 placeholder=\"Enter portion of Name\" ng-model=vmCIP.sFirstName ng-keypress=vmCIP.enterKeyHandler($event)></div></form><form ng-show=\"vmCIP.search==\'email\'\"><div><label for=txtEmail>Email Address</label><input id=txtEmail class=input-text-full type=text class=form-control placeholder=\"Enter the complete Email Address\" ng-model=vmCIP.sEmail ng-keypress=vmCIP.enterKeyHandler($event)></div></form><div class=divCtr><div class=divLCtr><button class=\"btnCtr MCGold\" ng-click=vmCIP.searchForAPerson()>Search</button></div><div class=divRCtr><button class=btnCtr ng-click=vmCIP.clear()>Clear</button></div></div><!-- PeoResults & PeoDisplay go here:	 --><ui-view></ui-view>");
$templateCache.put("app/partials/ciPeoResults.html","<!-- CIPeoResultsController as vmCIPR --><div ng-show=\"vmCIPR.peopleResults.length > 0\"><h5>Click on a name to load the Contact<br>Information, or return to Search.</h5><table class=\"table table-hover\"><thead><th>Person Search Results:</th></thead><tbody><tr ng-repeat=\"person in vmCIPR.peopleResults | orderBy:PERSONNAMESORT track by $index\"><td ng-model=person.ENTITYID ng-class=\"{selEntity:person.ENTITYID === vmCIPR.selEntityID}\" ng-click=vmCIPR.loadContactInfo(person)><span class=primary>{{ person.PERSONNAME }}</span> <span ng-hide=\"vmCIPR.bHidePrimary==true\"><br>&nbsp;&nbsp;&nbsp; [{{person.PRIMARYCHURCH}}]<span></span></span></td></tr></tbody></table></div>");
$templateCache.put("app/views/about.html","<section class=section><div align=center><span style=\"font-size: 16px\">This software was created by<br>Great Spirit Systems Corporation&trade;<br>specializing in software development to<br>meet the unique needs of religious<br>organizations since 1994.<br><br>Inquiries should be addressed to<br><font color=#0000FF><a href=\"mailto:al@greatspirit.com?subject=Inquiry\"><u>al@greatspirit.com</u></a></font></span></div></section>");
$templateCache.put("app/views/appSelect.html","<section class=section><div align=center><span class=txtMCRed style=\"font-size: 20px\"><b>You are logged in!</b></span><br><br><span style=\"font-size: 16px\">You have access to more than one<br>MissionConnect application.<br>Select the desired application from<br>the MENU button in the upper-right corner.</span></div></section>");
$templateCache.put("app/views/chgPW.html","<section class=section><!-- ChgPasswordController as vmCP --><div><h5><b>Tips for making the password stronger:</b></h5><ul><li>Make it longer</li><li>Use both UPPER &amp; lower case</li><li>Add a number</li><li>Add a special character: #*@!&amp;,^%</li></ul></div><div class=form-group><label for=txtOldPW>Old Password</label><input id=txtOldPW class=form-control type=text autofocus ng-model=vmCP.data.oldPW></div><h5>[New Password must not match old]</h5><div class=form-group><label for=txtNewPW>New Password</label><input id=txtNewPW class=form-control type=password placeholder=\"Enter NEW Password\" ng-model=vmCP.data.newPW ng-change=vmCP.checkPWStrength() ng-blur=\"vmCP.confirmReadyToSave(\'pw\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><div>Password Strength is&nbsp;&nbsp;<span id=pwStrength class=\"ng-class: vmCP.sPWClass\">&nbsp;&nbsp;<b>{{ vmCP.sPasswordStrength }}</b>&nbsp;&nbsp;</span></div><div class=form-group><label for=txtConfirmPW>Confirm Password</label><input id=txtConfirmPW class=form-control type=password placeholder=\"Confirm Password\" ng-model=vmCP.data.confirmPW ng-blur=\"vmCP.confirmReadyToSave(\'pw\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><h5><b>Current User Account Email: {{ vmCP.sUserEmail }}</b></h5><div class=div><label for=email>Update Email Address</label><input id=email class=form-control type=text ng-model=vmCP.data.email ng-blur=\"vmCP.confirmReadyToSave(\'email\')\"></div><div class=div><label for=confirmEmail>Confirm Email Address</label><input id=confirmEmail class=form-control type=text ng-model=vmCP.data.confirmEmail ng-blur=\"vmCP.confirmReadyToSave(\'email\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><div class=divR><button ng-click=vmCP.cancelChanges()>Cancel</button> <button id=saveNewPW class=\"ng-class: vmCP.bReadyToSave\" style=width:100px ng-click=vmCP.saveChanges()>Save</button></div></section>");
$templateCache.put("app/views/churchLdrshp.html","<section><!-- ChurchLdrshpController as vmCL --><div id=vChLdrshp><h2>Church Leadership App goes here!</h2></div></section>");
$templateCache.put("app/views/confSel.html","<section class=vhCtr><!-- ConfSelController as vmCS --><div class=divCtr><h4 class=txtCtr>Select your Conference:</h4><div class=divCtr><select id=ddlConfs ng-model=vmCS.selConf ng-change=vmCS.selectConference() ng-keypress=vmCS.enterKeyHandler($event) ng-options=\"conf as conf.CUSTOMERNAME for conf in vmCS.Confs\"></select></div><div><button class=\"btnCtr mcGold\" ng-click=vmCS.cmdContinue_clickHandler($event)>Continue</button></div></div></section>");
$templateCache.put("app/views/contactInfo.html","<!-- ContactInfoController as vmCI (not created) --><section class=section><h4 class=txtCtr>Contact Information</h4><div class=divCtr><div class=divLCtr><button class=btnCtr ui-sref=peoFind>Person Search</button></div><div class=divRCtr><button class=btnCtr ui-sref=chFind>Church Search</button></div></div><div><ui-view></ui-view></div></section>");
$templateCache.put("app/views/helpDesk.html","<section class=section><!-- HelpDeskController vmHD --><div style=\"font-size: 21px; font-weight: bold\">MissionConnect: Help Desk</div><div class=form-group><label>Name:</label><input class=form-control placeholder=\"Enter Full Name\" type=text autofocus ng-model=vmHD.sUserFullName value=\"{{ vmHD.sUserFullName }}\" ng-change=vmHD.confirmReadyToSubmit()></div><div class=form-group><label>Email:</label><input class=form-control placeholder=\"Email Address\" type=text value=\"{{ vmHD.sUserEmail }}\" ng-model=vmHD.sUserEmail ng-change=vmHD.confirmReadyToSubmit()></div><div class=form-group><label>Describe the problem. Please include details.</label><textarea class=form-control ng-model=vmHD.sProblem ng-change=vmHD.confirmReadyToSubmit()></textarea></div><div><button id=submitHD class=btnCtr ng-class=vmHD.bReadyToSubmit ng-click=vmHD.submitHD()>Submit</button></div></section>");
$templateCache.put("app/views/login.html","<section><div uib-alert ng-if=\"vmLI.sMaintenanceMsg !== \'\'\" class=\"alert alert-danger text-center\"><span ng-bind-html=vmLI.sMaintenanceMsg></span></div><div class=section><h4 class=txtCtr>Select your Conference:</h4><div><select class=ddlCtr ng-model=vmLI.selConf ng-change=vmLI.selectConference() ng-options=\"cust as cust.CustomerName for cust in vmLI.custDB | \n					orderBy:cust.DataSource\" ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></select></div></div><div><hr><h5><b>Login to access Secure Applications</b><br><span class=txtMCRed>Username &amp; Password are Case Sensitive!</span></h5><div class=form-group><label for=txtUsername>Username</label><input id=txtUsername type=text class=form-control autofocus placeholder=Username ng-model=vmLI.sUsername ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></div><div class=form-group><label for=txtPassword>Password</label><input id=txtPassword class=form-control type=password placeholder=Password ng-model=vmLI.sPassword ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></div><div><div class=divL><button class=\"btn115 MCGold\" ng-click=vmLI.validateUserLogin() ng-keypress=vmLI.enterKeyHandler($event)>Login</button></div><div class=divR><button ng-click=vmLI.forgotPassword_clickHandler()>Forgot Password?</button></div></div></div><div class=div><h5>[For security reasons, the application will log off if idle for 30 minutes.]</h5></div></section>");
$templateCache.put("app/views/newAcct.html","<section><!-- NewAcctController as vmUA --><div class=div ng-show=\"vmUA.sDatabaseID==\'MC\' || vmUA.sDatabaseID==\'MC-DEV\'\"><img style=width:100% ng-src=\"{{ vmUA.imgMCBanner.image }}\" alt=\"McCurdy Ministries\"></div><h4 style=\"text-align: center\">Create a New Account</h4><div class=section><div><h5><b>Tips for making the password stronger:</b></h5><ul><li>Make it longer</li><li>Use both UPPER &amp; lower case</li><li>Add a number</li><li>Add a special character: #*@!&amp;,^%</li></ul></div><div><div class=divL><label for=firstName class=required>First Name</label><input name=firstName type=text class=form-control style=width:130px ng-model=vmUA.data.firstName autofocus></div><div class=divL><label for=lastName class=required>Last Name</label><input name=lastName type=text class=form-control style=width:165px ng-model=vmUA.data.lastName autofocus></div><div class=div><label for=userName class=required>User Name <span style=font-weight:400;color:#000>[Minimum of 4 characters]</span></label><input id=userName class=form-control type=text autofocus class=form-control ng-model=vmUA.data.userName ng-blur=\"vmUA.confirmReadyToSave(\'username\')\"></div><div class=div>Password Strength is:&nbsp;&nbsp; <span id=pwStrength class=\"ng-class: vmUA.sPWClass\">&nbsp;&nbsp;<b>{{ vmUA.sPasswordStrength }}</b>&nbsp;&nbsp;</span></div><div class=div><label for=password class=required>Password</label><input id=password class=form-control type=password ng-model=vmUA.data.password ng-change=vmUA.checkPWStrength() ng-blur=\" vmUA.confirmReadyToSave(\'pw\')\" ng-keypress=vmUA.enterKeyHandler($event)></div><div class=div><label for=confirmPW class=required>Confirm Password</label><input id=confirmPW class=form-control type=password ng-model=vmUA.data.confirmPW ng-blur=\"vmUA.confirmReadyToSave(\'pw\')\" ng-keypress=vmUA.enterKeyHandler($event)></div><div class=div><label for=email class=required>Email Address</label><input id=email class=form-control type=text ng-model=vmUA.data.email ng-blur=\"vmUA.confirmReadyToSave(\'email\')\"></div><div class=div><label for=confirmEmail class=required>Confirm Email Address</label><input id=confirmEmail class=form-control type=text ng-model=vmUA.data.confirmEmail ng-blur=\"vmUA.confirmReadyToSave(\'email\')\" ng-keypress=vmUA.enterKeyHandler($event)></div></div><div class=divR><button ui-sref=login>Cancel</button> <button id=saveNewPW class=\"ng-class: vmUA.bReadyToSave\" style=width:100px ng-click=vmUA.saveNewAccount()>Save</button></div></div></section>");}]);